gameController = {};
//////////////////////////////////////////////////////
// New Spinner
gameController.dynamicSpinner = true;
//////////////////////////////////////////////////////
gameController.gameLoaded = false;
gameController.inFreeSpins = false;
gameController.cyclingWins = false;
gameController.spinComplete = false;
gameController.onlyCaughtFish = false;
gameController.bonusSymbolsLanded = 0;
gameController.minBonusForFeature = 3;
gameController.arrowAnimsCount = 0;
gameController.arrowAnimsComplete = 0;
gameController.anticipationVisible = false;
gameController.canSlamStop = false;
gameController.slamStopped = false;
gameController.preFSReelPrize = 0;
gameController.inBuyABonus = false;
gameController.buyBonusLow = false;
gameController.buyBonusMed = false;
gameController.buyBonusHigh = false;
gameController.inBuyABonusFirstSpin = true;
gameController.justHadFreeSpins = false;
gameController.spinTuneId = undefined;
gameController.idleTuneId = undefined;
gameController.reelspinId = 0;
gameController.magicBet = false;
gameController.symbolLandAnimator = undefined;
gameController.inRespin = false;
gameController.platformPaused = false;
gameController.platformPopupActive = false;
gameController.popupShown = false;
gameController.stakeChanged = false;

gameController.symbolFramePanels = [];
gameController.respinAnticipationSymbolFrames = [];
gameController.respinInitialCoinsLanded = null;

gameController.canSkipWin = false;
gameController.winningsCountup = undefined;
gameController.inRecovery = false;
gameController.isPrepaid = false;
gameController.inBuyABonusRecovery = false;
gameController.lastFishermanData = undefined;
gameController.fsWinnings = 0;
gameController.currentStake = 0;
gameController.muteCyclingWins = false;
gameController.finalFreeSpin = false;
gameController.skipWinsPressed = false;
gameController.totalWinnings = 0;

gameController.devilLevel = 1;

gameController.currentGems = [];
gameController.gemSymbols = [8, 9, 10, 11];
gameController.coinsAndGems = [5, 6, 7, 8, 9, 10, 11, 22, 23];
gameController.sparkleTimer = undefined;
gameController.sparkle = undefined;
gameController.sparkleTween = undefined;
gameController.coinBurstEmitter = undefined;

gameController.idle = true;
gameController.logoSpineInterval = null;
gameController.pots = [];
gameController.potSwipes = [];
gameController.meterMasks = [];

gameController.persistentValues = undefined;

gameController.justLeftBuyABonus = false;
gameController.justEnteredBuyABonus = false;

gameController.awardPayLinesBeforeCollectables = undefined;
gameController.spinToCollectables = undefined;
gameController.nudgeModifier = undefined;
gameController.boostModifier = undefined;
gameController.multiModifier = undefined;
gameController.collectableAwards = undefined;
gameController.treasureChestAdd = undefined;
gameController.treasureChestClose = undefined;
gameController.firewaveActive = false;
gameController.devilProgress = undefined;
gameController.devilReel = 7;
gameController.standardCollectSymbol = 16;
gameController.boostCollectSymbol = 17;
gameController.multiplierCollectSymbol = 18;
gameController.respinCollectSymbol = 19;
gameController.leftEmitterSpawnX = -130;
gameController.leftEmitterSpawnY = -262;
gameController.rightEmitterSpawnX = 139;
gameController.rightEmitterSpawnY = -254;

//respin
gameController.respinData = undefined;
gameController.isRespinning = false;
gameController.hasRespun = false;

//treasure chest
gameController.treasureChestLeftSize = 0;
gameController.treasureChestRightSize = 0;

gameController.anticipationSounds = ["reelAnticipation1", "reelAnticipation2", "reelAnticipation3"];

gameController.fishermanAnimsComplete = false;
gameController.landedFishermen = [];
gameController.newlyLocked = [];
gameController.allLockedFishermen = [];
gameController.previousLockedFishermen = [];
gameController.anchorLocks = 0;

gameController.bonusSymbolsToAnimate = [];
gameController.bonusSymbolsCurrent = [];

gameController.meterOverlays = [];
gameController.meterOverlaysCreated = 0;
gameController.currentMeterOverlays = [];
gameController.cashOverlays = [];
gameController.cashOverlaysCreated = 0;
gameController.crtCashAnimations = [];
gameController.multiplierOverlays = [];
gameController.showMultipliers = false;
gameController.multiplierOverlaysCreated = 0;
gameController.currentMutlipliers = [];

gameController.wildOverlays = [];
gameController.wildOverlaysCreated = 0;
gameController.currentWilds = [];

gameController.wildEmitters = [];

gameController.animatedReelFish = false;

gameController.fishermenToReel = 0;
gameController.currentReelingIndex = 0;

gameController.boughtBonus = false;

gameController.finishedCatching = false;
gameController.cashCoinsAnimationsComplete = false;
gameController.chestsComplete = false;
gameController.modifierComplete = false;
gameController.nudgeComplete = false;
gameController.postRespinBigWinAnimsComplete = false;

gameController.winlineSounds = ["winline1", "winline2", "winline3"];
gameController.winlineSoundsIndex = 0;

gameController.gambleModeModes = ["five", "on", "off"];
gameController.gambleMode = "five";
gameController.gambleModeIndex = 0;

gameController.trailLevel = 1;
gameController.currentBand = "default";

gameController._COIN_SYMBOL_IDS = [];
gameController._GEM_SYMBOL_IDS = [];

// respin data
gameController.respinModifier = undefined;
gameController.respinSymbolTracker = undefined;
gameController.respinIndexTracker = 0;
gameController.coinsLandedTracker = null;

gameController.anticipateCentreReel = false;
gameController.canSecondSlam = false;

//////////////////////////////////////////////////////
// Jamie - To control FS animation speeds
gameController.wildPanelParticleSpeedScaler = 2000;
gameController.mainReelsParticleSpeedScaler = 2000;
//////////////////////////////////////////////////////
gameController.switchGambleMode = function () {
  let len = gameController.gambleModeModes.length - 1;
  let temp = gameController.gambleModeIndex;
  temp++;

  if (temp < 0) {
    temp = len;
  } else if (temp > len) {
    temp = 0;
  }

  gameController.gambleModeIndex = temp;
  gameController.gambleMode = gameController.gambleModeModes[temp];

  return temp;
};

gameController.fadeSound = function (soundsToFade, fadeTo, time, fadeIn) {
  timerManager.addTimer(
    time,
    function (progress) {
      soundsToFade.forEach(function (sound) {
        if (sound) {
          let fade = fadeTo * (1 - progress);
          if (fadeIn) {
            fade = fadeTo * progress;
          }
          soundManager.setVolume(fade, sound);
        }
      });
    },
    function () {
      soundsToFade.forEach(function (sound) {
        if (sound) {
          soundManager.setVolume(fadeTo, sound);
        }
      });
    }
  );
};

gameController.initialise = function () {
  const { symbols } = resourceManager.getConfiguration();
  gameController._COIN_SYMBOL_IDS = [
    symbols["CoinM7"].ID,
    symbols["CoinM6"].ID,
    symbols["CoinM5"].ID,
    symbols["CoinM8"].ID,
    symbols["CoinM9"].ID,
    symbols["CoinM7x2"].ID,
    symbols["CoinM7x3"].ID,
    symbols["CoinM7x4"].ID,
    symbols["CoinM7x5"].ID,
    symbols["CoinM6x2"].ID,
    symbols["CoinM6x3"].ID,
    symbols["CoinM6x4"].ID,
    symbols["CoinM6x5"].ID,
    symbols["CoinM5x2"].ID,
    symbols["CoinM5x3"].ID,
    symbols["CoinM5x4"].ID,
    symbols["CoinM5x5"].ID,
    symbols["CoinM8x2"].ID,
    symbols["CoinM8x3"].ID,
    symbols["CoinM8x4"].ID,
    symbols["CoinM8x5"].ID,
    symbols["CoinM9x2"].ID,
    symbols["CoinM9x3"].ID,
    symbols["CoinM9x4"].ID,
    symbols["CoinM9x5"].ID,
  ];
  gameController._GEM_SYMBOL_IDS = [
    symbols["MiniGreenGemM4"].ID,
    symbols["MinorBlueGemM3"].ID,
    symbols["MajorPurpleGemM2"].ID,
    symbols["GrandRedGemM1"].ID,
    symbols["MiniGreenGemM4x2"].ID,
    symbols["MiniGreenGemM4x3"].ID,
    symbols["MiniGreenGemM4x4"].ID,
    symbols["MiniGreenGemM4x5"].ID,
    symbols["MinorBlueGemM3x2"].ID,
    symbols["MinorBlueGemM3x3"].ID,
    symbols["MinorBlueGemM3x4"].ID,
    symbols["MinorBlueGemM3x5"].ID,
    symbols["MajorPurpleGemM2x2"].ID,
    symbols["MajorPurpleGemM2x3"].ID,
    symbols["MajorPurpleGemM2x4"].ID,
    symbols["MajorPurpleGemM2x5"].ID,
    symbols["GrandRedGemM1x2"].ID,
    symbols["GrandRedGemM1x3"].ID,
    symbols["GrandRedGemM1x4"].ID,
    symbols["GrandRedGemM1x5"].ID,
  ];

  gameController.persistentValues = gameData.slotConfig.persistentValues;
  gameController.rng = new RNG();
  gameController.uiRandomSeedRNG = new RNG();

  const { leftChestColour, leftChestSize, rightChestColour, rightChestSize, devilLevel, nextDevilCount } =
    gameController.persistentValues;
  gameController.chests = resourceManager.get("chestsContainer");
  gameController.collectMeter = resourceManager.get("collectMeterContainer");
  gameController.collectMeter.initialise();
  gameController.chests.initialise();
  gameController.chests.setInitialState({
    leftChestColour,
    leftChestSize,
    rightChestColour,
    rightChestSize,
  });
  gameController.collectMeter.setInitialState({ devilLevel, nextDevilCount });
  console.log(devilLevel);
  console.log(gameController.devilLevel);
  gameController.devilLevel = devilLevel;

  gameController.sparkle = resourceManager.get("gemSparkle");
  gameController.sparkle.visible = false;

  gameController.devilCharacter = resourceManager.get("devilCharacterContainer:devilCharacter");
  gameController.centreDevil = resourceManager.get("centreDevil");
  gameController.modifierAwardedPanel = resourceManager.get("modifierAwardedPanel");

  gameController.createPotSwipeShines();

  // resourceManager.getContainer("soundTrack").visible = true;

  //Modifiers
  gameController.boostMod = resourceManager.get("boostModifier");
  gameController.multiMod = resourceManager.get("multiModifier");

  gameController.bigWin = resourceManager.get("bigWin");
  gameController.bigWin.init();

  gameController.reelBorderFire = resourceManager.get("preReels:reelFrameContainer:reelBorderFire");

  gameController.createParticleEmitters();

  CoinsView.initialise();
  gameController.devilCharacter.initialise();
  gameController.centreDevil.initialise();
  gameController.boostMod.initialise();
  gameController.multiMod.initialise();
  gameController.reelBorderFire.initialise();
  gameController.modifierAwardedPanel.initialise();

  autoplayManager.dialog.buttonGlow = resourceManager.get("buttonContainer:buttonBar:autoplayButton:glow");

  const volumeButton = resourceManager.get("buttonContainer:buttonBar:mute");
  volumeButton.canShowBase = volumeButton.canShow;
  const canEnableSound = settingsMenu.buttons.btnSound.visible;
  const settingsEnabled = settingsMenu.buttons.btnSettings.enabled;
  volumeButton.canShow = function () {
    const soundButton = resourceManager.get("systemSettings:systemSettingsBox:settingSound");
    soundButton.setActive(canEnableSound);

    if (!canEnableSound && settingsEnabled) {
      // remove the sound cog button
      resourceManager.get("settingsMenu:background:graphics3").visible = false;
    }

    return this.canShowBase() && settingsMenu.buttons.btnSound.visible;
  };

  gameController.coinBurstEmitter = particleManager.createEmitter(
    "bigwin_emitter_2",
    "particlesContainerGems",
    0,
    0,
    false
  );
  gameController.coinBurstEmitter.particleEmitter.emit = false;

  gameController.setupSlotAnimVisuals();
  gameController.unlockIntroPanel = resourceManager.get("unlocksIntroPanel");

  const params = {
    scale: 0.2,
    startSpeed: 60,
    endSpeed: 40,
    lifetime: 5,
    frequency: 0.06,
    clear: true,
  };

  gameController.slotMachine = resourceManager.getController("DevilsSlotMachine");

  const reelNames = [
    "reel0",
    "reel1",
    "reel2",
    "reel3",
    "reel4",
    "reel5",
    "reel6",
    "reel7",
    "reel8",
    "reel9",
    "reel10",
    "reel11",
    "reel12",
    "reel13",
    "reel14",
  ];

  gameController.splashScreenComplete = function (callback) {
    const sp = gdk.getServerParser();
    gameController.isReplay = sp.isReplayMode !== undefined ? sp.isReplayMode() : false;

    if (!gameController.isReplay && !gameController.dontShowUnlockIntroPanel) {
      gameController.unlockIntroPanel.startPopup(gameController.devilLevel, callback);
    } else {
      callback();
      gameController.dontShowUnlockIntroPanel = false;
    }
  };

  gameController.slotMachine.subscribeToAccelerationStartedEvent((reelId) => {
    if (reelId === "reel7") {
      gameController.centreDevil.disappear(gameController.inFreeSpins);
    }
  });

  gameController.slotMachine.subscribeToReelsLandedEvent(function (reelId) {
    const reel = reelNames.indexOf(reelId);

    gameController.stoppedReels[reel] = true;
    gameController.onSpinLand(reel);
  });

  gameController.slotMachine.subscribeToReelsHitEvent(function (reelId) {
    const reel = reelNames.indexOf(reelId);
    gameController.onSpinHit(reel);
  });

  gameController.slotMachine.selectReelMode("default");

  gameController.winlineAnimator = resourceManager.getSharedPlugin("WinlineAnimatorEx");

  const slamStopButton = resourceManager.get("buttonContainer:buttonBar:slamStopButton");
  slamStopButton.canEnableBase = slamStopButton.canEnable;
  slamStopButton.canEnable = function () {
    return this.canEnableBase() && gameController._receivedResponse;
  };

  gameController.symbolLandAnimator = resourceManager.get("slotContainer:BonusLandAnimator");

  gameController.winControllerMain = resourceManager.getController("WinControllerMain");

  gameController.winlinePopup = resourceManager.get("winlinePopupContainer");
  gameController.winlinePopup.visible = false;

  gameController.winlinePopupText = resourceManager.get("winlinePopupContainer:linePays");
  gameController.devilPaysPopupText = resourceManager.get("winlinePopupContainer:devilPays");

  gameController.scatterSymbolReels = [];

  gameController.symbolAnimator = resourceManager.get("slotContainer:SymbolAnimator");

  if (gameController.dynamicSpinner) {
    gameController.slotMachine.setDynamicSpinner(true);
    gameController.slotMachine.setInjectorMode("devilLevel1");
  }

  gameController.createLogoSpine();

  musicManager.onGameLoaded();

  Reflex.registerEventHandler("orientationChange", gameController.onOrientationChange);

  gameController.timeScale = 1;
  document.addEventListener("keydown", game.onKeyDown);

  //initialise pot meter values
  gameController.potMeters = resourceManager.get("potMetersContainer");
  gameController.potMeters.initialise();

  autoplayManager.dialog.buttonGlow.visible = false;

  gameController.setDarkOverlay();
};

gameController.setDarkOverlay = (orientationChange = false) => {
  gameController.reelDark = resourceManager.get("reelDarkContainer:reelDark");
  const reelBacking = resourceManager.get("preReels:reelFrameContainer:reelFrameBack");

  const anchorX = reelBacking.anchor?.x ?? 0;
  const anchorY = reelBacking.anchor?.y ?? 0;

  const topLeftLocalPoint = new PIXI.Point(-anchorX * reelBacking.width, -anchorY * reelBacking.height);

  const bottomRightLocalPoint = new PIXI.Point((1 - anchorX) * reelBacking.width, (1 - anchorY) * reelBacking.height);

  const topLeftGlobal = reelBacking.toGlobal(topLeftLocalPoint);
  const bottomRightGlobal = reelBacking.toGlobal(bottomRightLocalPoint);

  const topLeftLocal = gameController.reelDark.parent.toLocal(topLeftGlobal);
  const bottomRightLocal = gameController.reelDark.parent.toLocal(bottomRightGlobal);

  const width = bottomRightLocal.x - topLeftLocal.x;
  const height = bottomRightLocal.y - topLeftLocal.y;

  gameController.reelDark.clear();
  gameController.reelDark.beginFill(0x000000);
  gameController.reelDark.lineStyle(0, 0x000000);
  gameController.reelDark.drawRect(0, 0, width, height);
  gameController.reelDark.endFill();

  gameController.reelDark.position.set(topLeftLocal.x, topLeftLocal.y);

  if (!orientationChange) {
    gameController.reelDark.visible = false;
  }
};

gameController.createLogoSpine = function () {
  const contLandscape = resourceManager.get("postReels:logoContainer");

  gameController.logoLandscape = resourceManager.createObject("spine", "LogoSpine", contLandscape, {
    name: "LogoSpine",
    defaultAnimation: "animation",
    scaleX: 1,
    scaleY: 1,
  });
};

gameController.startLogoAnimLoop = () => {
  if (gameController.logoSpineInterval) clearInterval(gameController.logoSpineInterval);

  gameController.logoSpineInterval = setInterval(() => {
    if (document.visibilityState === "visible" && gameController.idle) {
      gameController.playLogoSpine();
      if (!gameController.isFreespinsEntry) {
        gameController.chests._wiggleChest("left", false);
        gameController.chests._wiggleChest("right", false);

        gameController.playPotSwipes();
      }
      gameController.collectMeter.idleTextAnim();

      if (!gameController.devilCharacter.idle) {
        gameController.devilCharacter.sleepAnimation();
      }
    }
  }, 5000);
};

gameController.stopLogoAnimLoop = () => {
  if (gameController.logoSpineInterval) {
    clearInterval(gameController.logoSpineInterval);
    gameController.logoSpineInterval = null;
  }
};

gameController.setLogoIdle = (value) => {
  gameController.idle = value;
  if (gameController.idle) {
    gameController.startLogoAnimLoop();
  } else {
    gameController.stopLogoAnimLoop();
    if (gameController.devilCharacter.idle) {
      gameController.chests.playLockWiggle();
      gameController.devilCharacter.leaveSleepAnimation();
    }
  }
};

gameController.createPotSwipeShines = function () {
  const names = ["grand", "major", "minor", "mini"];

  for (let i = 0; i < 4; i++) {
    const mask = resourceManager.get(`potMetersContainer:${names[i]}Meter:meterMask`);
    const swipe = resourceManager.get(`potMetersContainer:${names[i]}Meter:swipe`);
    const pot = resourceManager.get(`potMetersContainer:${names[i]}Meter`);

    mask.mask = swipe;
    swipe.x = -112;
    swipe.visible = false;
    mask.visible = false;

    gameController.potSwipes.push(swipe);
    gameController.pots.push(pot);
    gameController.meterMasks.push(mask);
  }
};

gameController.playPotSwipes = function () {
  const tl = gsap.timeline();

  const duration = 0.7;
  const interval = 0.4;

  for (let i = 0; i < 4; i++) {
    const swipe = gameController.potSwipes[i];
    const pot = gameController.pots[i];
    const scale = pot.scale.x;
    const scaleGsap = scale * 1.02;
    const mask = gameController.meterMasks[i];

    const startTime = 1 + i * interval;

    tl.set(swipe, { x: -112, visible: true }, startTime);
    tl.set(mask, { visible: true }, startTime);

    tl.to(
      pot,
      {
        duration: duration / 2,
        pixi: { scaleX: scaleGsap, scaleY: scaleGsap },
        repeat: 1,
        yoyo: true,
        ease: "power1.inOut",
      },
      startTime
    );

    tl.to(
      swipe,
      {
        duration,
        x: 112,
        onComplete: () => {
          swipe.visible = false;
          mask.visible = false;
        },
      },
      startTime
    );
  }
};

gameController.playLogoSpine = () => {
  gameController.logoLandscape.play("animation");
};

gameController.toggleReelDark = function (show, duration = 0.3, delay = 0) {
  if (show) {
    gameController.reelDark.visible = true;
    gameController.reelDark.alpha = 0;
    gsap.to(gameController.reelDark, {
      duration,
      delay,
      alpha: 0.5,
    });
  } else {
    gsap.to(gameController.reelDark, {
      duration,
      delay,
      alpha: 0,
      onComplete: () => {
        gameController.reelDark.visible = false;
      },
    });
  }
};

gameController.onKeyDown = function (event) {};

gameController.setTimeScale = function () {
  PIXI.ticker.shared.speed = gameController.timeScale;
  gsap.globalTimeline.timeScale(gameController.timeScale);
};

gameController.setupSlotAnimVisuals = function () {
  for (var reel = 0; reel < 15; reel++) {
    const pos = helpers.getSymbolPos(reel, 0);

    let symbolFrame = resourceManager.createObject("movie", "symbolFrame" + reel, "particlesContainerFront", {
      definition: "symbolFrame",
      x: pos.x,
      y: pos.y,
      anchor: 0.5,
      scale: 1.0,
      loop: false,
    });
    symbolFrame.gotoAndStop(0);
    symbolFrame.visible = false;
    gameController.symbolFramePanels.push(symbolFrame);

    const scale = resourceManager.get("slotContainer").scale;
    // get anticipation symbol frames
    const anticipationSymbolFrame = resourceManager.createObject(
      "movie",
      "respinAnticipationSymbolFrame" + reel,
      "particlesContainerFront",
      {
        definition: "respinAnticipationSymbolFrame",
        x: pos.x,
        y: pos.y - 20 * scale.y,
        anchor: 0.5,
        loop: true,
      }
    );
    anticipationSymbolFrame.scale = scale;
    anticipationSymbolFrame.gotoAndStop(0);
    anticipationSymbolFrame.alpha = 0;
    gameController.respinAnticipationSymbolFrames.push(anticipationSymbolFrame);
  }
};

gameController.onSpinHit = function (reel) {
  const finalReel = gameController.inFreeSpins ? 14 : 7;
  if (reel === finalReel) {
    gameController.firewaveActive = false;
  }

  if (gameController.isRespinning) {
    gameController.coinsLandedTracker[gameController.respinIndexTracker - 1].forEach((coinLandedReelIndex) => {
      if (coinLandedReelIndex === reel) {
        gsap.to(gameController.respinAnticipationSymbolFrames[coinLandedReelIndex], { alpha: 1, duration: 0.5 });
        gameController.respinAnticipationSymbolFrames[coinLandedReelIndex].play();
        soundManager.play("coinWin");
      }
    });
    const landedSymbol = gameController.respinData[gameController.respinIndexTracker - 1].find(
      (entry) => entry.reelIndex === reel
    );
    if (landedSymbol != null && gameController._GEM_SYMBOL_IDS.includes(landedSymbol.symbol)) {
      soundManager.play("gemLand");
    }
  } else {
    if (reel % 3 === 2) {
      soundManager.play("reelStopLastRow");
    }

    if (gameController.hasReelGotGem(reel)) {
      soundManager.play("gemLand");
    } else if (gameController.hasReelGotCoin(reel)) {
      soundManager.play("coinLand");
    }
  }
};

gameController.fishermanLand = function (fishermen) {
  for (i = 0; i < fishermen.length; i++) {
    const coord = fishermen[i];
    const pos = helpers.getSymbolPos(coord.reel, coord.row);
    const emitter = gameController.getWildEmitter();

    const scale = resourceManager.get("slotContainer").scale;

    emitter.x = pos.x;
    emitter.y = pos.y;
    emitter.scale = scale;
    emitter.particleEmitter.emit = true;

    timerManager.addTimeout(500, () => {
      gameController.wildEmitters.push(emitter);
    });
  }
};

gameController.getWildEmitter = function () {
  let emitter = undefined;

  if (gameController.wildEmitters.length > 0) {
    emitter = gameController.wildEmitters.pop();
  } else {
    emitter = particleManager.createEmitter("wildEmitter", "fishermenOverlayContainer", 0, 0, false);
  }
  return emitter;
};

gameController.start = function () {
  gameController.stateMachine.switchState("WAITING_FOR_START");
};

gameController.shuffle = function (array) {
  var currentIndex = array.length,
    temporaryValue,
    randomIndex;

  // While there remain elements to shuffle...
  while (0 !== currentIndex) {
    // Pick a remaining element...
    randomIndex = Math.floor(Math.random() * currentIndex);
    currentIndex -= 1;

    // And swap it with the current element.
    temporaryValue = array[currentIndex];
    array[currentIndex] = array[randomIndex];
    array[randomIndex] = temporaryValue;
  }

  return array;
};

gameController.onSpinComplete = function () {
  if (gameController.isRespinning) {
    gameController.doRespin();
  } else {
    if (gameController.hasRespun) {
      gameController.respinAnticipationSymbolFrames.forEach((symbolFrame) => {
        gsap.to(symbolFrame, { alpha: 0, duration: 0.5 }).then(() => {
          symbolFrame.gotoAndStop(0);
        });
      });
      gameController.devilCharacter.idleLoop();
      gameController.respinFinished = true; // just need to think about where this is cleared
      gameController.isLastRespin = false; // should make the spin button come back
    }

    gameController.slotMachine.clearHeldReels();
    gameController.previousLockedFishermen = gameController.allLockedFishermen;
    gameController.canSlamStop = false;
    gameController.anticipationVisible = false;
    gameController.spinComplete = true;
    gameController._receivedResponse = true;
    gameController.slamStopped = false;
    gameData.reelsSpinning = 0;

    // soundManager.stop("reelSpin");
    gameController.stateMachine.switchState("WAITING_FOR_REELS");
  }
};

gameController.getIsRecovery = function () {
  return gameController.inRecovery;
};

gameController.animateFSSpinSymbolLand = function (reel) {};

gameController.animateFSSpinSymbolWin = function (reel, callback) {};

gameController.isBonusThisSpin = function () {
  let bonusCount = 0;
  for (let i = 0; i < gameData.numReels; i++) {
    bonusCount += gameController.countBonusOnReel(i);
  }
  return bonusCount >= gameController.minBonusForFeature;
};

gameController.isBonusPossible = function (reel) {
  switch (reel) {
    case 0: {
      return true;
    }
    case 1: {
      return gameController.bonusSymbolsLanded !== 0;
    }
    case 2: {
      return gameController.bonusSymbolsLanded >= 2;
    }
    case 3: {
      return gameController.bonusSymbolsLanded >= 2;
    }
    case 4: {
      return gameController.bonusSymbolsLanded >= 3;
    }
  }
};

gameController.hasReelGotCoin = function (reel) {
  const reelIndex = Math.floor(reel / 3);
  const symbolIndex = reel % 3;
  let reelSymbols = [];
  if (gameController.spinTask.data.resultsPanel !== undefined) {
    reelSymbols = gameController.spinTask.data.resultsPanel.reelList[reelIndex].symbols;
  }
  if (gameController.spinTask.data.resultPanel !== undefined) {
    reelSymbols = gameController.spinTask.data.resultPanel.reelList[reelIndex].symbols;
  }
  return gameController._COIN_SYMBOL_IDS.includes(reelSymbols[symbolIndex].value);
};

gameController.hasReelGotGem = function (reel) {
  const reelIndex = Math.floor(reel / 3);
  const symbolIndex = reel % 3;
  let reelSymbols = [];
  if (gameController.spinTask.data.resultsPanel !== undefined) {
    reelSymbols = gameController.spinTask.data.resultsPanel.reelList[reelIndex].symbols;
  }
  if (gameController.spinTask.data.resultPanel !== undefined) {
    reelSymbols = gameController.spinTask.data.resultPanel.reelList[reelIndex].symbols;
  }
  return gameController._GEM_SYMBOL_IDS.includes(reelSymbols[symbolIndex].value);
};

gameController.countSymbolOnReel = function (reel, symbolString) {
  let reelSymbols = [];
  if (gameController.spinTask.data.resultsPanel !== undefined) {
    reelSymbols = gameController.spinTask.data.resultsPanel.reelList[reel].symbols;
  }
  if (gameController.spinTask.data.resultPanel !== undefined) {
    reelSymbols = gameController.spinTask.data.resultPanel.reelList[reel].symbols;
  }

  const symbols = resourceManager.getConfiguration().symbols;
  const found = reelSymbols.find(function (symbol) {
    return symbol.value === symbols[symbolString].ID;
  });

  if (found !== undefined) {
    return 1;
  } else {
    return 0;
  }
};

gameController.countBonusOnReel = function (reel) {
  return (
    gameController.countSymbolOnReel(reel, "FS") +
    gameController.countSymbolOnReel(reel, "FSS") +
    gameController.countSymbolOnReel(reel, "FSM")
  );
};

gameController.countLogoOnReel = function (reel) {
  return gameController.countSymbolOnReel(reel, "Logo");
};

gameController.onSpinLand = function (reel) {
  gameController.landedReels[reel] = true;

  let respun = true;

  if (reel === 0) {
    const currentUnlockedModifiers = gameController.collectMeter.getCurrentUnlockedModifiers();
    if (gameController.inFreeSpins && !gameController.hasRespun && currentUnlockedModifiers.length > 0) {
      //gameController.centreDevil.showAnimatedBackground();
    }

    if (gameController.anticipateCentreReel) {
      soundManager.play("centreReelAnticipation");
      gsap.to(gameController.respinAnticipationSymbolFrames[7], { alpha: 1, duration: 0.5 });
      gameController.respinAnticipationSymbolFrames[7].play();
      gameController.anticipationVisible = true;
    }
  }

  if (reel === 7) {
    if (gameController.anticipateCentreReel) {
      gsap.to(gameController.respinAnticipationSymbolFrames[7], { alpha: 0, duration: 0.5 }).then(() => {
        gameController.respinAnticipationSymbolFrames[7].gotoAndStop(0);
      });
    }
  }

  gameData.reelsSpinning--;

  if (respun !== undefined) {
    gameController.respunIndex++;
  }

  if (gameController.isRespinning) {
    gameController.coinsLandedTracker[gameController.respinIndexTracker - 1].forEach((coinLandedReelIndex) => {
      if (coinLandedReelIndex === reel) {
        gsap.to(gameController.respinAnticipationSymbolFrames[coinLandedReelIndex], { alpha: 1, duration: 0.5 });
        gameController.respinAnticipationSymbolFrames[coinLandedReelIndex].play();
      }
    });
  }
};

gameController.checkNewlyLocked = function (cell) {
  gameController.allLockedFishermen.forEach((fisherman) => {
    const coord = fisherman.coord;

    if (coord.reel === cell.reel && coord.row === cell.row) {
      gameController.newlyLocked.push(cell);
      gameController.anchorLocks++;
    }
  });
};

gameController.onGameConfigEvent = function () {
  gameController.gameLoaded = true;
};

gameController.doSpin = function (spinTask) {
  gameController.anticipateCentreReel = false;
  gameController.canSecondSlam = false;

  !gameController.inFreeSpins && gameController.reelBorderFire.switchColour("Normal");

  gameController.setLogoIdle(false);
  gameController.stopSparkles();
  gameController.stateMachine.switchState("SPIN_REELS_SPINNING");

  console.log(gameController.devilLevel);

  if (gameController.devilLevel < 1 || gameController.devilLevel > 4) {
    console.error("Devil Level must be between 1-4. Currently: " + gameController.devilLevel);
  }

  const levelString = `devilLevel${gameController.devilLevel}`;
  gameController.slotMachine.selectReelMode(levelString);
  gameController.slotMachine.setInjectorMode(levelString);

  gameController.isPrepaid = spinTask.data.isPrePaidGame;
  gameController.hasRespun = false;

  gameController.idle = false;

  gameController.bonusSymbolsCurrent = [];

  gameController.preRespinWinnings = 0;

  // gameController.resetMultiplierDim();

  gameController.skipWinsPressed = false;
  gameController.respunReels = undefined;

  gameData.reelsSpinning = 15;

  gameController.finalFreeSpin = spinTask.data.finalFreeSpin;
  gameController.firstFreeSpin = spinTask.data.firstFreeSpin;

  if (gameController.inBuyABonus && gameController.inBuyABonusFirstSpin) {
    gameController.inBuyABonusFirstSpin = false;
  }

  if (spinTask.data.localRng) {
    gameController.rng.seed(spinTask.data.localRng);
  }

  if (spinTask.data.uiRandomSeed) {
    gameController.uiRandomSeedRNG.seed(spinTask.data.uiRandomSeed);
  }

  // Set up data for the reels
  let symbols = [];
  let above = [];
  let below = [];
  for (let reel = 0; reel < spinTask.data.resultPanel.reelList.length; reel++) {
    // above.push([]);
    // below.push([]);
    for (let row = 0; row < spinTask.data.resultPanel.reelList[reel].symbols.length; row++) {
      symbols.push([]);
      let index = helper.convertReelRowToIndex(reel, row);
      symbols[index].push(spinTask.data.resultPanel.reelList[reel].symbols[row].value);
      above.push([]);
      below.push([]);
    }
  }

  if (gameController.inBuyABonus && !gameController.centreDevil.devilVisible) {
    gameController.centreDevil.appear();
  }

  gameController.convertedReelResults = symbols;

  const currentUnlockedModifiers = gameController.collectMeter.getCurrentUnlockedModifiers();
  if (gameController.inFreeSpins && !gameController.hasRespun && currentUnlockedModifiers.length > 0) {
    gameController.centreDevil.showAnimatedBackground();
  }

  console.log(spinTask.data.resultPanel.reelList);
  console.log(gameController.convertedReelResults);

  gameData.spinData = spinTask.data;

  gameController.spinTask = spinTask;
  gameController.spinTask.join();
  console.log(gameController.persistentValues);

  if (gameController.inRecovery) {
    gameController.dontShowUnlockIntroPanel = true;
  }

  //Game Specific Variables
  gameController.awardPayLinesBeforeCollectables = spinTask.data.awardPayLinesBeforeCollectables;
  gameController.spinToCollectables = spinTask.data.spinToCollectables;
  gameController.nudgeModifier = spinTask.data.nudgeModifier;
  gameController.boostModifier = spinTask.data.boostModifier;
  gameController.multiModifier = spinTask.data.multiModifier;
  gameController.respinModifier = spinTask.data.respinModifier;
  gameController.collectableAwards = spinTask.data.collectableAwards;
  gameController.treasureChestAdd = spinTask.data.treasureChestAdd;
  gameController.treasureChestClose = spinTask.data.treasureChestClose;
  gameController.devilProgress = spinTask.data.devilProgress;
  gameController.canFirewave = spinTask.data.canFirewave;
  gameController.bonusBuyChestAdd = spinTask.data.bonusBuyChestAdd;

  console.log("awardPayLinesBeforeCollectables", gameController.awardPayLinesBeforeCollectables);
  console.log("spinToCollectables", gameController.spinToCollectables);
  console.log("nudgeModifier", gameController.nudgeModifier);
  console.log("boostModifier", gameController.boostModifier);
  console.log("multiModifier", gameController.multiModifier);
  console.log("respinModifier", gameController.respinModifier);
  console.log("collectableAwards", gameController.collectableAwards);
  console.log("treasureChestAdd", gameController.treasureChestAdd);
  if (gameController.treasureChestAdd) {
    console.log("left size", gameController.treasureChestAdd.left.newSizeIfIncreased);
    console.log("right size", gameController.treasureChestAdd.right.newSizeIfIncreased);
  }
  console.log("treasureChestClose", gameController.treasureChestClose);
  console.log("devilProgress", gameController.devilProgress);
  console.log("canFirewave", gameController.canFirewave);
  console.log("bonusBuyChestAdd", gameController.bonusBuyChestAdd);

  if (gameController.inBuyABonus /*and opened?*/) {
    // timerManager.addTimeout(600, function () {
    //   // if(gameController.bonusBuyChestAdd.isOpened){
    //   //   gameController.handleBonusBuyRetrigger();
    //   // } else {
    //   gameController.addToBonusChest();
    //   // }
    // });
    if (gameController.bonusBuyChestAdd) {
      timerManager.addTimeout(600, function () {
        if (gameController.bonusBuyChestAdd.left.isOpened || gameController.bonusBuyChestAdd.right.isOpened) {
          gameController.handleRetrigger(gameController.bonusBuyChestAdd);
          gameController.chestsComplete = true;
        } else if (gameController.bonusBuyChestAdd.left.addedTo && gameController.bonusBuyChestAdd.right.addedTo) {
          gameController.increaseBothBonusChests();
        } else if (gameController.bonusBuyChestAdd.left?.addedTo) {
          gameController.increaseLeftBonusChest();
        } else if (gameController.bonusBuyChestAdd.right?.addedTo) {
          gameController.increaseRightBonusChest();
        } else {
          gameController.chestsComplete = true;
        }
      });
    }
  } else {
    if (gameController.inFreeSpins && gameController.treasureChestAdd) {
      timerManager.addTimeout(600, function () {
        if (gameController.treasureChestAdd.left.isOpened || gameController.treasureChestAdd.right.isOpened) {
          gameController.handleRetrigger(gameController.treasureChestAdd);
          gameController.chestsComplete = true;
        } else if (gameController.treasureChestAdd.left?.addedTo && gameController.treasureChestAdd.right.addedTo) {
          gameController.increaseBothChests();
        } else if (gameController.treasureChestAdd.left?.addedTo) {
          gameController.increaseLeftChest();
        } else if (gameController.treasureChestAdd.right?.addedTo) {
          gameController.increaseRightChest();
        } else {
          gameController.chestsComplete = true;
        }
      });
    }
  }

  if (
    gameController.respinModifier &&
    gameController.respinModifier.isAwarded &&
    !gameController.isRespinning &&
    !gameController.hasRespun
  ) {
    gameController.preRespins = true;
  }

  let extraSpinTime = 1;

  if (gameController.canFirewave) {
    extraSpinTime = 4000;
    gameController.devilCharacter.fireWave();
  }
  !gameController.inFreeSpins && gameController.checkCentreReelAnticipation(spinTask.data);

  spinController.stopSpin(symbols, above, below, gameController.onSpinComplete, gameController.nudgeModifier);
  timerManager.addTimeout(extraSpinTime, () => {
    gameController._receivedResponse = true;
  });
};

gameController.checkCentreReelAnticipation = (spinTask) => {
  const currentStake = resourceManager.getController("stakeController").getBaseStake();

  const spinToCollectablesWinAmount = spinTask.spinToCollectables.reduce((acc, curr) => {
    const collectableValue = curr.type === "Gem" ? curr.potValue : curr.amount;
    return (acc += collectableValue);
  }, 0);

  const canAnticipateCentreReel =
    spinTask.spinToCollectables.length >= 5 || spinToCollectablesWinAmount >= currentStake * 10;

  spinController.longSpinMainReels = Array(15).fill(false);

  if (canAnticipateCentreReel) {
    spinController.longSpinMainReels[7] = true;
    gameController.anticipateCentreReel = true;
  }
};

gameController.injectCoinsAndGems = () => {
  for (let i = 0; i < 15; i++) {
    if (i !== 7) {
      let anticipationSymbols5 = {
        reel: i,
        symId: 5, //sym id to show coin/gem
        count: 3,
        minGap: 3,
      };
      gameController.slotMachine.insertAnticipationSymbols(anticipationSymbols5);
      let anticipationSymbols6 = {
        reel: i,
        symId: 6, //sym id to show coin/gem
        count: 3,
        minGap: 3,
      };
      gameController.slotMachine.insertAnticipationSymbols(anticipationSymbols6);
      let anticipationSymbols7 = {
        reel: i,
        symId: 7, //sym id to show coin/gem
        count: 3,
        minGap: 3,
      };
      gameController.slotMachine.insertAnticipationSymbols(anticipationSymbols7);
      let anticipationSymbols8 = {
        reel: i,
        symId: 8, //sym id to show coin/gem
        count: 3,
        minGap: 3,
      };
      gameController.slotMachine.insertAnticipationSymbols(anticipationSymbols8);
      let anticipationSymbols9 = {
        reel: i,
        symId: 9, //sym id to show coin/gem
        count: 3,
        minGap: 3,
      };
      gameController.slotMachine.insertAnticipationSymbols(anticipationSymbols9);
      let anticipationSymbols10 = {
        reel: i,
        symId: 10, //sym id to show coin/gem
        count: 3,
        minGap: 3,
      };
      gameController.slotMachine.insertAnticipationSymbols(anticipationSymbols10);
      let anticipationSymbols11 = {
        reel: i,
        symId: 11, //sym id to show coin/gem
        count: 3,
        minGap: 3,
      };
      gameController.slotMachine.insertAnticipationSymbols(anticipationSymbols11);
      let anticipationSymbols22 = {
        reel: i,
        symId: 22, //sym id to show coin/gem
        count: 3,
        minGap: 3,
      };
      gameController.slotMachine.insertAnticipationSymbols(anticipationSymbols22);
      let anticipationSymbols23 = {
        reel: i,
        symId: 23, //sym id to show coin/gem
        count: 3,
        minGap: 3,
      };
      gameController.slotMachine.insertAnticipationSymbols(anticipationSymbols23);
    }
  }
};

gameController.handleRetrigger = async (chests) => {
  let handleRetriggerResolve;
  gameController.handleRetriggerPromise = new Promise((res) => {
    handleRetriggerResolve = res;
  });
  const { left: leftChest, right: rightChest } = chests;

  if (leftChest.isOpened && rightChest.isOpened) {
    gameController.centreDevil.bothChests();
    await gameController.shootParticle(true, true);
    await gameController.chests._setSize(gameController.inBuyABonus ? "leftBonus" : "left", 5, true);
    await gameController.chests._setSize(gameController.inBuyABonus ? "rightBonus" : "right", 5, true);
    await gameController.chests.playFreeSpinsAwarded(
      gameController.inBuyABonus ? "leftBonus" : "left",
      gameController.inBuyABonus ? undefined : 5,
      leftChest.spinsInChest
    );
    await gameController.chests.playFreeSpinsAwarded(
      gameController.inBuyABonus ? "rightBonus" : "right",
      gameController.inBuyABonus ? undefined : 5,
      rightChest.spinsInChest
    );
  } else if (leftChest.isOpened) {
    gameController.centreDevil.leftChest();
    await gameController.shootParticle(true, false);
    gameController.centreDevil.idleLoop();
    await gameController.chests.playFreeSpinsAwarded(
      gameController.inBuyABonus ? "leftBonus" : "left",
      gameController.inBuyABonus ? undefined : 5,
      leftChest.spinsInChest
    );
  } else if (rightChest.isOpened) {
    gameController.centreDevil.rightChest();
    await gameController.shootParticle(false, true);
    gameController.centreDevil.idleLoop();
    await gameController.chests.playFreeSpinsAwarded(
      gameController.inBuyABonus ? "rightBonus" : "right",
      gameController.inBuyABonus ? undefined : 5,
      rightChest.spinsInChest
    );
  }
  handleRetriggerResolve();
};

// gameController.handleBonusBuyRetrigger = async () => {
//   gameController.centreDevil.rightChest();
//   await gameController.shootParticle(false, false, true);
//   gameController.centreDevil.idleLoop();
//   await gameController.chests.playFreeSpinsAwarded("bonus", undefined, gameController.bonusBuyChestAdd.spinsInChest); //bonuschest spins needed
// };

gameController.isInRespinModifier = function () {
  return this.isRespinning || this.isLastRespin;
};

gameController.doRespin = async function () {
  setTimeout(async () => {
    gameController.canFirewave = false;
    gameController.firewaveActive = false;
    if (gameController.respinIndexTracker === 0) {
      gameController.cashCoinsAnimationsComplete = false;
      gameController.hasRespun = true;
      gameController.preRespins = false;

      await gameController.centreDevil.respinIntro();
      !gameController.inFreeSpins && gameController.reelBorderFire.switchColour("Red");
    }

    gameController.canSlamStop = false;
    gameController.slamStopped = false;
    messageBus.postImmediate("respin");

    // start spinning the reels
    const reelsToSpin = gameController.respinData[gameController.respinIndexTracker].map((respinReel) => {
      gameController.respinIndexTracker === 0 && gameController.dimFullReel(respinReel.reelIndex, true);
      return respinReel.reelIndex;
    });

    spinController.startSpin(reelsToSpin);

    gameController.respinIndexTracker === 0 &&
      gameController.respinInitialCoinsLanded.forEach((hasCoinLanded, index) => {
        if (hasCoinLanded) {
          gsap.to(gameController.respinAnticipationSymbolFrames[index], {
            alpha: 1,
            duration: 0.5,
          });
          gameController.respinAnticipationSymbolFrames[index].play();
        }
      });

    gameController.respunIndex = 0;

    //gameController.slotMachine.dimAllSymbols(false, 0.1);

    gameController._receivedResponse = true;
    gameController.skipWinsPressed = false;

    gameData.reelsSpinning = 15;

    gameController.respinSymbolTracker.forEach((symbol, index) => {
      const symbolToChange = gameController.respinData[gameController.respinIndexTracker].find(
        (respin) => respin.reelIndex === index
      );

      if (symbolToChange) {
        gameController.respinSymbolTracker[index] = [symbolToChange.symbol];
      }
    });

    if (gameController.respinIndexTracker === gameController.respinData.length - 1) {
      gameController.isRespinning = false;
      gameController.isLastRespin = true;
    } else {
      gameController.respinIndexTracker++;
    }

    spinController.stopSpin(
      gameController.respinSymbolTracker,
      Array.from({ length: 15 }, () => []),
      Array.from({ length: 15 }, () => []),
      gameController.onSpinComplete
    );
  }, 0);
};

gameController.handleRespinSymbolBorders = (reelsToSpin) => {
  reelsToSpin.forEach((reelToSpin) => {
    gameController.symbolFramePanels[reelToSpin].visible = true;
    gameController.symbolFramePanels[reelToSpin].loop = true;
    gameController.symbolFramePanels[reelToSpin].play();
  });
};

gameController.initNewSpin = function () {
  musicManager.onGameStart();

  gameController.respinFinished = false;
  gameController._receivedResponse = false;
  gameController.stakeChanged = false;

  gameController.slamStopped = false;
  gameController.bonusSymbolsLanded = 0;
  gameController.waitingForLandAnim = false;
  gameController.cyclingWins = false;
  gameController.bigWin._newSpin = true;
  gameData.winningsText.skip();
  gameController.bigWin._newSpin = false;
  gameController.lastPayWinsData = undefined;
  gameController.spinComplete = false;
  gameController.cashCoinsAnimationsComplete = false;
  gameController.chestsComplete = false;
  gameController.modifierComplete = false;
  gameController.nudgeComplete = false;
  gameController.hasRespun = false;

  if (!gameController.inFreeSpins) {
    gameController.canSlamStop = true;
  }

  if (!gameController.inFreeSpins) {
    gameData.winningsMeter.set(0);
    gameController.totalWinnings = 0;
  }

  if (gameController.currentReelSpin !== undefined) {
    soundManager.stop(gameController.currentReelSpin);
  }

  // gameController.currentReelSpin = soundManager.play("reelSpin");
  gameController.symbolAnimator.skip();
  gameController.symbolLandAnimator.skip();

  for (let i = 0; i < 15; i++) {
    let reelVisual = resourceManager.get("slotContainer:reelContainer:reel" + i);
    reelVisual.multipliersActive = false;
  }

  gameController.stoppedReels = [
    false,
    false,
    false,
    false,
    false,
    false,
    false,
    false,
    false,
    false,
    false,
    false,
    false,
    false,
    false,
  ];
  gameController.landedReels = [
    false,
    false,
    false,
    false,
    false,
    false,
    false,
    false,
    false,
    false,
    false,
    false,
    false,
    false,
    false,
  ];

  const reelsToSpin = gameController.inFreeSpins
    ? gameController.landedReels.map((reel, index) => index !== 7 && index)
    : gameController.landedReels.map((reel, index) => index);

  spinController.startSpin(reelsToSpin);

  for (let reel = 0; reel < 15; reel++) {
    timerManager.addTimeout(1200, function () {
      if (!gameController.slamStopped) {
        const multiplierOverlay = resourceManager.get(`slotContainer:reelContainer:reel${reel}`)._multiplierOverlays[0];
        const multiplierTextOverlay = resourceManager.get(`slotContainer:reelContainer:reel${reel}`)
          ._multiplierTextOverlays[0];

        multiplierOverlay.modifiedValue = undefined;
        multiplierTextOverlay.modifiedValue = undefined;
      }
    });
  }

  gameController.slotMachine.dimAllSymbols(false, 0.1);

  gameController.setState_WaitingForServer();
  gameController.featurePrize = 0;
  gameController.reelsPrize = 0;
};

gameController.initNewGame = function (becauseOfRecovery = false) {
  gameController.stopCyclingWins();
  gameController.muteCyclingWins = false;
  gameController.winlineAnimator.skipAnimation();
  gameController.winlineAnimator.clearWinlines();
  gameController.inBuyABonus = false;
  gameController.buyBonusLow = false;
  gameController.buyBonusMed = false;
  gameController.buyBonusHigh = false;
  gameController.inBuyABonusFirstSpin = true;
  gameController.preFSReelPrize = 0;
  gameController.stateMachine.switchState("GAME_PLAYING");

  if (!becauseOfRecovery) {
    gameController.initNewSpin();
  } else {
    // make sure symbol are correct
    // especially on br license and restore
    gameController.slotMachine.update(0);
  }
  gameController.initNewSpin();

  if (autoplayManager.isAutoplayEnabled()) {
    resourceManager
      .getController("inputOverlord")
      .setText("autoplayCancelButton", String(autoplayManager.getRemainingRounds() - 1));
  }
};

// set initial spin data (to set initial state when forcing)
gameController.setInitialSpinData = (initialPlayerState) => {
  const parsedInitialPlayerState = JSON.parse(initialPlayerState.state);
  const { leftChestColour, leftChestSize, rightChestColour, rightChestSize, devilLevel, nextDevilCount } =
    parsedInitialPlayerState;
  gameController.persistentValues = parsedInitialPlayerState;

  if (gameData.encoreEnabled) {
    gameController.chests.toggleGoldenBet(true);
  }
  gameController.collectMeter.setInitialState({ devilLevel, nextDevilCount });
  gameController.devilLevel = devilLevel;

  if (!gameController.inBuyABonus) {
    gameController.chests.setState({
      leftChestColour,
      leftChestSize,
      rightChestColour,
      rightChestSize,
    });
  }
};

gameController.startGame = function () {
  // Do not allow the user to spin if the buy bonus or autoplay dialog is visible
  let buyBonusPopUp = resourceManager.get("buyABonusContainer:buyBonusPopup");
  let autoplayPopUp = resourceManager.get("autoplayContainer:autoplayBacker");

  if (buyBonusPopUp.visible || autoplayPopUp.visible) return;

  gameController.justHadFreeSpins = false;

  gameController.initNewGame();

  const stakeController = resourceManager.getController("stakeController");
  let bpl = stakeController.BaseStake / stakeController.CurrentWinLineCount;

  gdk.startGame(
    {
      stake: stakeController.CurrentStake,
      numWinlines: stakeController.CurrentWinLineCount,
      bpl: bpl,
      metaData: {
        buyABonus: false,
        encore: gameData.encoreEnabled,
        gambleMode: gameController.gambleModeIndex,
      },
    },
    function () {
      gdk.getNextGameOutcome(function () {});
    }
  );
};

gameController.stopCyclingWins = function () {
  gameController.cyclingWins = false;
  gameController.symbolAnimator.skip();
  gameController.lastPayWinsData = undefined;
  gameController.cyclingWinsIndex = 0;
  gameController.stopSymbolFrameDisplay();
  gameController.winlinePopup.visible = false;
};

gameController.setState_WaitingForServer = function (eventToLeave) {
  gameController.isFreespinsEntry = false;
  if (gameController.hasRespun) {
    gameController.respinTask.leave();
    gameController.respinTask = undefined;
    gameController.isRespinning = false;
    gameController.respinIndexTracker = 0;
  } else {
    if (checkForDefined(eventToLeave)) {
      eventToLeave.leave();
    }
  }
};

gameController.checkForSymbolOnFullReels = function (symbol) {
  for (let reel = 0; reel < 5; reel++) {
    for (let row = 0; row < 3; row++) {
      if (gameController.spinTask.data.resultPanel.reelList[reel].symbols[row].value === symbol) {
        return true;
      }
    }
  }
  return false;
};

gameController.autoplayStarted = function (autoplayData) {
  autoplayManager.dialog.buttonGlow.visible = true;
};

gameController.autoplayEnded = function (autoplayData) {
  resourceManager.getController("inputOverlord").setText("autoplayCancelButton", "");

  autoplayManager.dialog.buttonGlow.visible = false;
};

StateMachine.Create(gameController);

gameController.stateMachine.addState("WAITING_FOR_LOAD", function () {});

gameController.cancelAutoplay = function () {
  resourceManager.getController("autoplayController").cancel();

  autoplayManager.dialog.buttonGlow.visible = false;
};

gameController.increaseChestWait = async () => {
  if (!gameController.inFreeSpins) {
    return new Promise((res) => gsap.delayedCall(0.5, res));
  } else {
    return Promise.resolve();
  }
};

gameController.increaseLeftChest = async function () {
  gameController.centreDevil.leftChest();
  await gameController.shootParticle(true, false);
  await gameController.increaseChestWait();
  await gameController.chests._setSize(
    "left",
    gameController.treasureChestAdd.left?.increased
      ? gameController.treasureChestAdd.left?.newSizeIfIncreased
      : undefined,
    true
  );
};

gameController.increaseRightChest = async function () {
  gameController.centreDevil.rightChest();
  await gameController.shootParticle(false, true);
  await gameController.increaseChestWait();
  await gameController.chests._setSize(
    "right",
    gameController.treasureChestAdd.right.increased
      ? gameController.treasureChestAdd.right.newSizeIfIncreased
      : undefined,
    true
  );
};

gameController.increaseBothChests = async function () {
  gameController.centreDevil.bothChests();
  await gameController.shootParticle(true, true);
  await gameController.increaseChestWait();
  await gameController.chests._setSize(
    "left",
    gameController.treasureChestAdd.left?.increased
      ? gameController.treasureChestAdd.left?.newSizeIfIncreased
      : undefined,
    true
  );
  await new Promise((res) => gsap.delayedCall(1, res));
  await gameController.chests._setSize(
    "right",
    gameController.treasureChestAdd.right.increased
      ? gameController.treasureChestAdd.right.newSizeIfIncreased
      : undefined,
    true
  );
};
gameController.increaseLeftBonusChest = async function () {
  gameController.centreDevil.leftChest();
  await gameController.shootParticle(true, false);
};

gameController.increaseRightBonusChest = async function () {
  gameController.centreDevil.rightChest();
  await gameController.shootParticle(false, true);
};

gameController.increaseBothBonusChests = async function () {
  gameController.centreDevil.bothChests();
  await gameController.shootParticle(true, true);
};

gameController.addToBonusChest = async function () {
  gameController.centreDevil.rightChest();
  await gameController.shootParticle(false, false, true);
  if (gameController.bonusBuyChestAdd.isOpened) {
    await gameController.chests.playFreeSpinsAwarded("bonus", undefined, gameController.bonusBuyChestAdd.spinsInChest);
    gameController.chestsComplete = true;
  } else {
    gameController.chestsComplete = true;
  }
};

gameController.stateMachine.addState("WAITING_FOR_REELS", function () {
  if (gameController.phase.hold()) {
    if (gameController.spinComplete) {
      gameController.phase.step();
    }
  }
  if (gameController.phase.once()) {
    gameController.slotMachine.clearDimSymbolIds();
    gameController.stateMachine.switchState("WAITING_FOR_BONUSES");
  }
});

gameController.stateMachine.addState("WAITING_FOR_BONUSES", async function () {
  if (gameController.phase.once()) {
    // HANDLE NUDGE MODIFIER
    if (gameController.nudgeModifier && gameController.nudgeModifier.isAwarded && !gameController.hasRespun) {
      // get middle symbol value
      const endSymbol = gameController.spinTask.data.resultPanel.reelList[2].symbols[1].value;
      await nudgeHandler.nudgeSymbols(gameController.nudgeModifier, endSymbol);
    }

    let showFrustratedDevil = false;
    // HANDLE ADDING TO CHESTS
    if (!gameController.hasRespun) {
      if (!gameController.inFreeSpins) {
        if (gameController.treasureChestAdd.left?.isOpened || gameController.treasureChestAdd.right.isOpened) {
          await gameController.handlePreFreespinsEntry();
        } else if (gameController.treasureChestAdd.left?.addedTo && gameController.treasureChestAdd.right.addedTo) {
          await gameController.increaseBothChests();
          showFrustratedDevil = true;
        } else if (gameController.treasureChestAdd.left?.addedTo) {
          showFrustratedDevil = true;
          await gameController.increaseLeftChest();
        } else if (gameController.treasureChestAdd.right?.addedTo) {
          showFrustratedDevil = true;
          await gameController.increaseRightChest();
        }
      }
    }

    const hasRespunAndNotFull =
      gameController.hasRespun &&
      gameController.respinModifier.respins[gameController.respinModifier.respins.length - 1].blanks.length !== 0;

    // POST INCREASE CHEST ANIMS (if any)
    if (
      hasRespunAndNotFull ||
      (showFrustratedDevil &&
        !gameController.spinTask.data.collectableAwards.winAmount &&
        !gameController.spinTask.data.hasPaylines)
    ) {
      await gameController.centreDevil.frustrated();
      gameController.centreDevil.idleLoop();
    }
    // if it's free spins entry, has paylines but no collectables then play centreDevil idleLoop whilst we award paylines.
    if (
      gameController.isFreespinsEntry &&
      gameController.spinTask.data.hasPaylines &&
      gameController.collectableAwards.awards.length === 0
    ) {
      gameController.centreDevil.idleLoop();
    }

    // HANDLE MODIFIERS
    if (gameController.boostModifier.isAwarded && gameController.boostModifier.boostedCollectables.length > 0) {
      !gameController.inFreeSpins && gameController.reelBorderFire.switchColour("Green");
      await gameController.boostMod.start();
    } else if (gameController.multiModifier.isAwarded && gameController.collectableAwards.awards.length > 0) {
      !gameController.inFreeSpins && gameController.reelBorderFire.switchColour("Blue");
      await gameController.multiMod.start();
    }

    // HANDLE CENTRE DEVIL
    if (!gameController.preRespins && gameController.checkForDevilSymbol()) {
      await gameController.centreDevil.handleCentreDevil(gameController.isFreespinsEntry);
    }

    // HANDLE ADDING TO COLLECT METER
    // trigger collect meter here if there's no winlines and no collectables (also called in winlineAnimsDone for if there are winlines)
    if (
      !gameController.inFreeSpins &&
      gameController.checkForDevilSymbol() &&
      !gameController.spinTask.data.hasPaylines &&
      gameController.collectableAwards.awards.length === 0
    ) {
      await gameController.checkToCollectMeter();
    }

    // HANDLE BONUS/SetState
    gameController.setState_WaitingForServer(gameController.spinTask);
  }
});

gameController.checkToCollectMeter = async () => {
  if (gameController.collectMeter.currentDevilLevel !== 4) {
    const devilProgress = gameController.spinTask.data.devilProgress;
    musicManager.playDevilLaughSound();
    await new Promise((res) => gsap.delayedCall(0, res));
    await gameController.devilCharacter.shootToCollectMeter();
    soundManager.play("devilNudge2");
    await gameController.collectMeter.animateMeterValue(devilProgress);
  }
};

gameController.handlePreFreespinsEntry = async () => {
  gameController.isFreespinsEntry = true;
  const { left: leftChest, right: rightChest } = gameController.treasureChestAdd;

  if (leftChest.isOpened && rightChest.isOpened) {
    gameController.centreDevil.bothChests();
    await gameController.shootParticle(true, true);
    await gameController.increaseChestWait();
    await gameController.chests._setSize("left", 5, true);
    await gameController.chests.playFreeSpinsAwarded("left", 5, leftChest.spinsInChest);

    await gameController.increaseChestWait();
    await gameController.chests._setSize("right", 5, true);
    await gameController.chests.playFreeSpinsAwarded("right", 5, rightChest.spinsInChest);
  } else if (leftChest.isOpened) {
    if (rightChest.addedTo) {
      gameController.centreDevil.bothChests();
      await gameController.shootParticle(true, true);
      await gameController.increaseChestWait();
      await gameController.chests._setSize("left", 5, true);
      await gameController.chests.playFreeSpinsAwarded("left", 5, leftChest.spinsInChest);
      
      await gameController.increaseChestWait();
      await gameController.chests._setSize(
        "right",
        rightChest.increased ? rightChest.newSizeIfIncreased : undefined,
        true
      );
    } else {
      gameController.centreDevil.leftChest();
      await gameController.shootParticle(true, false);
      await gameController.increaseChestWait();
      await gameController.chests.playFreeSpinsAwarded("left", 5, leftChest.spinsInChest);
    }
  } else if (rightChest.isOpened) {
    if (leftChest.addedTo) {
      gameController.centreDevil.bothChests();
      await gameController.shootParticle(true, true);
      await gameController.increaseChestWait();
      await gameController.chests._setSize(
        "left",
        leftChest.increased ? leftChest.newSizeIfIncreased : undefined,
        true
      );
      
      await gameController.increaseChestWait();
      await gameController.chests._setSize("right", 5, true);
      await gameController.chests.playFreeSpinsAwarded("right", 5, rightChest.spinsInChest);
      
    } else {
      gameController.centreDevil.rightChest();
      await gameController.shootParticle(false, true);
      await gameController.increaseChestWait();
      await gameController.chests.playFreeSpinsAwarded("right", 5, rightChest.spinsInChest);
    }
  }
};

gameController.checkForCoinCollect = function () {
  return gameController.collectableAwards.awards.length > 0 && !gameController.isRespinning;
};

gameController.checkForDevilSymbol = function () {
  const devilSymbolIds = [16, 17, 18, 19];
  return devilSymbolIds.includes(gameController.convertedReelResults[gameController.devilReel][0]);
};

gameController.getHookedSymbols = function () {
  for (i = 0; i < gameController.hookData.newScatters.length; i++) {
    const coord = gameController.hookData.newScatters[i];
    let symData = {
      cell: { reel: coord.reel, row: coord.row },
      symbolId: 17,
    };
    gameController.bonusSymbolsToAnimate.push(symData);
  }
};

gameController.stateMachine.addState("WAITING_FOR_START", function () {
  if (gameController.phase.once()) {
    resourceManager.getController("inputOverlord").setState("enabled");
    resourceManager.getController("autoplayController").checkLimits();
  }

  if (gameController.phase.hold()) {
    if (!resourceManager.getController("autoplayController").LimitPopupOpen) {
      gameController.phase.step();
    }
  }

  if (gameController.phase.once()) {
    if (!autoplayManager.isAutoplayEnabled() && !gameController.justHadFreeSpins) {
      gameController.cyclingWins = true;
      gameController.cycleWins();

      gameController.findGems();
      gameController.startRandomSparkleTimer();
    }
  }

  if (gameController.phase.hold()) {
    // Waiting for player to do something
    if (autoplayManager.isAutoplayEnabled()) {
      if (autoplayManager.AP.getFields()["numberOfRounds"].currentValue !== autoplayManager.AP.roundsRemaining()) {
        var timeToNext = 500;
        resourceManager.getController("autoplayController").timeToNextAutoplay = timeToNext;
        gameController.phase.step();
      }
    }
  }

  if (gameController.phase.timed(resourceManager.getController("autoplayController").timeToNextAutoplay)) {
  }

  if (gameController.phase.once()) {
    gameController.startGame();
    if (autoplayManager.AP.roundsRemaining() === 0) {
      // Last round, so cancel autoplays
      gameController.cancelAutoplay();
    }
  }
});

gameController.stateMachine.addState("SPIN_REELS_SPINNING", function () {});

gameController.stateMachine.addState("WAITING_FOR_SERVER", function () {});

gameController.stateMachine.addState("PAYING_TO_WINNINGS", function () {
  if (gameController.phase.enter()) {
    winMeter.meter.cancelCountUp();

    soundManager.play("winCountUp");
  }
  if (gameController.phase.hold()) {
    if (!gameData.winningsMeter.Props.isCounting) {
      // Finished counting
      if (!gameData.slotConfig.promotionActive) {
        resourceManager.get("winningsMeterLabel").visible = true;
      }

      gameController.unFadeSymbols();

      gameController.stateMachine.switchState("DELAY_SHOW_WINNINGS");

      soundManager.stop("winCountUp");
      soundManager.play("winCountUpEnd");
    } else {
      if (!gameData.slotConfig.promotionActive) {
        resourceManager.get("winningsMeterLabel").visible = gameController.gameTime % 200 < 100;
      }
    }
  }

  if (gameController.phase.exit()) {
    if (!gameData.slotConfig.promotionActive) {
      resourceManager.get("winningsMeterLabel").visible = true;
    }
  }
});

gameController.stateMachine.addState("GAME_PLAYING", function () {
  if (gameController.phase.enter()) {
  }
});

gameController.stateMachine.addState("GAME_ENDED", function () {
  if (gameController.phase.enter()) {
    gameController.canSkipWin = false;
    gameController.respinFinished = false;
  }

  if (gameController.phase.once()) {
    gdk.endGame(function () {
      if (!gameData.mainTunePlaying && !gameController.inFreeSpins) {
        gameData.mainTunePlaying = true;
      }
      gameController.stateMachine.switchState("WAITING_FOR_START");
      gameController.baseSpin = true;
    });
  }
});

gameController.findGems = function () {
  gameController.currentGems = [];

  for (var i = 0; i < 15; i++) {
    const reel = resourceManager.get("slotContainer:reelContainer:reel" + i);

    const sym = reel.getReelSymbol(0);

    if (gameController.gemSymbols.includes(sym)) {
      gameController.currentGems.push(i);
    }
  }
};

gameController.stopSparklesTimer = function () {
  if (gameController.sparkleTimer) {
    timerManager.stop(gameController.sparkleTimer);
    gameController.sparkleTimer = null;
  }
};

gameController.stopSparkles = function () {
  this.stopSparklesTimer();

  if (gameController.sparkleTween) {
    gameController.sparkleTween.progress(1);
  }
};

gameController.animateSparkle = async function () {
  gameController.sparkleTween = gsap
    .timeline()
    .call(() => {
      gameController.sparkle.visible = true;
      gameController.sparkle.rotation = 0;
      gameController.sparkle.alpha = 0;
      gameController.sparkle.scale.set(0.5);
    })
    .to(gameController.sparkle, {
      duration: 0.3,
      alpha: 1,
      pixi: { scaleX: 1, scaleY: 1 },
    })
    .to(
      gameController.sparkle,
      {
        duration: 1,
        rotation: Math.PI * 2,
      },
      "<"
    )
    .to(
      gameController.sparkle,
      {
        duration: 0.3,
        alpha: 0,
        pixi: { scaleX: 0.5, scaleY: 0.5 },
        onComplete: () => {
          gameController.sparkle.visible = false;
          gameController.sparkleTween = undefined;
        },
      },
      ">-0.3"
    );
};

gameController.randomNumberBetween = function (min, max) {
  min = Math.ceil(min);
  max = Math.floor(max + 1);
  return Math.floor(Math.random() * (max - min)) + min;
};

gameController.playSparklesIfRequired = function () {
  if (gameController.currentGems.length === 0) {
    return;
  }

  const randomGem = gameController.randomNumberBetween(0, gameController.currentGems.length - 1);
  const coords = helpers.getSymbolPos(gameController.currentGems[randomGem], 0);

  gameController.sparkle.x = coords.x + 2;
  gameController.sparkle.y = coords.y - 56;
  gameController.animateSparkle();

  gameController.startRandomSparkleTimer();
};

gameController.startRandomSparkleTimer = function () {
  let randomDelayInMS = gameController.randomNumberBetween(2, 4) * 1000;
  gameController.sparkleTimer = timerManager.addTimeout(randomDelayInMS, () => {
    gameController.playSparklesIfRequired();
  });
};

gameController.stateMachine.switchState("WAITING_FOR_LOAD");

gameController.update = function (delta, time) {
  gameController.stateMachine.update();
};

gameController.getMainReelBonusAnimations = function () {
  for (var i = 0; i < 5; i++) {
    const reel = resourceManager.get("slotContainer:reelContainer:reel" + i);

    for (let j = 0; j < 3; ++j) {
      const sym = reel.getReelSymbol(j);

      if (sym === 17) {
        const symData = {
          cell: { reel: i, row: j },
          symbolId: 17,
        };
        gameController.bonusSymbolsToAnimate.push(symData);
      }
    }
  }
};

gameController.resetHideMultipliers = function () {
  for (var i = 0; i < 5; i++) {
    const reel = resourceManager.get("slotContainer:reelContainer:reel" + i);

    reel.showMultiplier(true);
  }
};

gameController.cycleWins = function (once, callback) {
  if (gameController.cyclingWins) {
    if (gameController.lastPayWinsData !== undefined && gameController.lastPayWinsData.winningLines !== undefined) {
      if (!gameController.isRespinning && !gameController.hasRespun) {
        gameController.cyclingWinsIndex = 0;
        gameController.cycleWin();
      }
      if (gameController.collectableAwards.awards.length && gameController.lastPayWinsData.winningLines.length === 0) {
        gameController.cycleCollectables();
      }
    }
  }
};

gameController.cycleCollectables = async () => {
  gameController.winlinePopup.visible = true;
  gameController.winlinePopupText.visible = false;
  gameController.devilPaysPopupText.visible = true;
  gameController.devilPaysPopupText.setTranslationParameters(
    gdk.formatCurrency(gameController.collectableAwards.winAmount)
  );

  gameController.cyclingWins && CoinsView.doCashCoins();
  gameController.cyclingWins && (await CoinsView.cashCoinsCompletePromise);
  gameController.cyclingWins && (await new Promise((res) => gsap.delayedCall(1, res)));
  gameController.cyclingWins && gameController.cycleCollectables();
};

gameController.cycleWin = function () {
  let canCelebrate =
    this.lastPayWinsData.totalLineWinnings > resourceManager.getController("stakeController").CurrentStake;

  if (gameController.lastPayWinsData.winningLines.length !== 0) {
    gameController.symbolAnimating = true;

    let data = gameController.lastPayWinsData.winningLines[gameController.cyclingWinsIndex];

    gameController.winlinePopup.visible = true;
    gameController.winlinePopupText.visible = true;
    gameController.devilPaysPopupText.visible = false;
    gameController.winlinePopupText.setTranslationParameters(data.winningLine, gdk.formatCurrency(data.winAmount));

    soundManager.play(gameController.winlineSounds[gameController.winlineSoundsIndex]);

    gameController.winlineSoundsIndex++;

    if (gameController.winlineSoundsIndex >= gameController.winlineSounds.length) {
      gameController.winlineSoundsIndex = 0;
    }

    let symbols = [];

    for (let i = 0; i < data.positions.length; ++i) {
      // is the devil anim playing over reel 7?
      if (data.positions[i].reel === 7 && gameController.centreDevil.devilVisible === true) {
        // we dont need to animate this symbol!
        // otherwise we get a brief flicker of horns
      } else {
        symbols.push({
          cell: { reel: data.positions[i].reel, row: data.positions[i].row },
          symbolId: data.symbol.ids[i],
        });
      }
    }

    if (canCelebrate) {
      gameController.symbolAnimator.animateSymbols(
        symbols,
        gameController.slotMachine,
        canCelebrate,
        false,
        function () {
          gameController.cycleWinDelay();
        }
      );
    } else {
      timerManager.addTimer(500, undefined, function () {
        gameController.cycleWinDelay();
      });
    }

    let frameData = {
      winningLines: [gameController.lastPayWinsData.winningLines[gameController.cyclingWinsIndex]],
    };

    gameController.displaySymbolFrames(frameData);

    gameController.animating = true;

    gameController.winlineAnimator.playAnimations(
      [gameController.lastPayWinsData.winningLines[gameController.cyclingWinsIndex]],
      function () {
        gameController.animating = false;
        gameController.symbolAnimating = false;
      },
      true,
      false
    );
  }
};

gameController.convertSymbols = function (symbols) {
  let convertedSymbols = [];
  symbols.forEach((sym) => {
    let reelIndex = helper.convertReelRowToIndex(sym.cell.reel, sym.cell.row);
    sym.cell.reel = reelIndex;
    sym.cell.row = 0;
    convertedSymbols.push(sym);
  });
  return convertedSymbols;
};

gameController.setWinningsText = function (finalCount = false) {
  const currentStake = resourceManager.getController("stakeController").getBaseStake();

  let winnings;

  if (gameController.postRespinTask) {
    winnings = gameController.postRespinTask.data.postRespinData.totalWinnings;
  } else if (
    gameController.inFreeSpins &&
    gameController.preRespins &&
    gameController.winTask.data.paylines.winningLines.length
  ) {
    winnings = gameController.winTask.data.paylines.winningLines.reduce((acc, curr) => curr.winAmount + acc, 0);
    gameController.preRespinWinnings = winnings;
  } else if (gameController.lastPayWinsData === undefined) {
    winnings = gameController.totalWinnings;
  } else {
    winnings = gameController.lastPayWinsData.totalLineWinnings;
  }

  if (finalCount || winnings < currentStake * 5 || gameController.skipWinsPressed) {
    gameData.winningsText.setText(winnings);
  } else {
    soundManager.play("winCountUp");

    const obj = { amount: 0 };
    gameController.winningsCountup = gsap.to(obj, {
      duration: 0.9,
      amount: winnings,
      onUpdate: () => {
        gameData.winningsText.setText(obj.amount);
      },
      onComplete: () => {
        soundManager.stop("winCountUp");
        soundManager.play("winCountUpEnd");
        gameController.winningsCountup = undefined;
      },
    });
  }
};

gameController.cycleWinDelay = function () {
  timerManager.addTimer(1000, undefined, function () {
    gameController.symbolAnimating = false;
    gameController.cycleNextWin();
  });
};

gameController.cycleNextWin = async function () {
  if (
    gameController.cyclingWins &&
    !gameController.symbolAnimating &&
    !gameController.animating &&
    gameController.lastPayWinsData &&
    gameController.lastPayWinsData.winningLines
  ) {
    if (gameController.cyclingWinsIndex < gameController.lastPayWinsData.winningLines.length - 1) {
      gameController.cyclingWinsIndex++;
      gameController.cycleWin();
    } else {
      if (gameController.collectableAwards.awards.length) {
        gameController.winlinePopup.visible = true;
        gameController.winlinePopupText.visible = false;
        gameController.devilPaysPopupText.visible = true;
        gameController.devilPaysPopupText.setTranslationParameters(
          gdk.formatCurrency(gameController.collectableAwards.winAmount)
        );
        CoinsView.doCashCoins();
        await CoinsView.cashCoinsCompletePromise;
        await new Promise((res) => gsap.delayedCall(1, res));
      }
      gameController.cycleWins();
    }
  }

  gameController.muteCyclingWins = true;
};

gameController.onLimitsPopupClosed = function () {
  soundManager.play(gameData.sounds.buttonPressed);
  gameController.stateMachine.switchState("GAME_ENDED");
};

gameController.onStakeChanged = function (stake) {
  const currentStake = gameData.stakes[gameData.currentStakeIndex];
  if (stake === undefined) {
    return;
  }

  gameController.currentStake = currentStake;
  if (currentStake !== stake) {
    gameData.currentStakeIndex = gameData.stakes.indexOf(stake);
    game.changeStake(stake);
    gameController.currentStake = stake;
    gameData.winningsMeter.set(0);

    if (!gameController.justLeftBuyABonus && !gameController.justEnteredBuyABonus) {
      gameController.stopCyclingWins();
    } else {
      gameController.justLeftBuyABonus = false;
    }

    resourceManager.get("potMetersContainer").updateMeterValues();

    const goldenText = resourceManager.get(
      "buttonContainer:buttonBar:luckyBetToggleButton:luckyBetMessage:luckyBetTextStake"
    );
    goldenText.setTranslationParameters(gdk.formatCurrency(stake));
  }
};

gameController.getCurrentModeStake = function (ignoreGoldenBetMultiplier) {
  let stake = 0;

  const stakeController = resourceManager.getController("stakeController");

  if (stakeController) {
    stake = stakeController.getBaseStake();

    if (gameController.inBuyABonus) {
      if (gameController.buyBonusLow) {
        stake = stakeController.getCurrentStake("BONUS_BUY_LOW");
      }
      if (gameController.buyBonusMed) {
        stake = stakeController.getCurrentStake("BONUS_BUY_MED");
      }
      if (gameController.buyBonusHigh) {
        stake = stakeController.getCurrentStake("BONUS_BUY_HIGH");
      }
    }
  }
  return stake;
};

gameController.onGameComplete = function () {
  if (!gameController.isPrepaid && !gameController.inRecovery && !gameController.hasRespun) {
    gameData.creditMeter.set(gameData.credit + gameController.totalWinnings);
    // gameData.creditMeterMobile.set(gameData.credit + gameController.totalWinnings);
  }

  if (gameController.inBuyABonus) {
    gameController.justLeftBuyABonus = true;
    resourceManager.getController("stakeController").broadcastCurrentStake("default");
  }

  gameController.setLogoIdle(true);
  gameController.canSkipWin = false;

  gdk.endGame(function () {
    if (autoplayManager.isAutoplayEnabled() === false) {
      resourceManager.getController("inputOverlord").setState("enabled");

      gameController.stateMachine.switchState("WAITING_FOR_START");
    } else {
      gameController.stateMachine.switchState("WAITING_FOR_START");
    }

    if (!musicManager.wasInFreeSpins) {
      musicManager.onGameEnd();
    } else {
      musicManager.wasInFreeSpins = false;
    }
  });
};

gameController.doSlamStop = function () {
  for (let reel = 0; reel < 15; reel++) {
    const multiplierOverlay = resourceManager.get(`slotContainer:reelContainer:reel${reel}`)._multiplierOverlays[0];
    const multiplierTextOverlay = resourceManager.get(`slotContainer:reelContainer:reel${reel}`)
      ._multiplierTextOverlays[0];

    multiplierOverlay.modifiedValue = undefined;
    multiplierTextOverlay.modifiedValue = undefined;
  }
  gameController.slamStopped = true;

  if (!gameController.respinModifier?.isAwarded || gameController.nudgeModifier?.isAwarded) {
    gameController.firewaveActive = false;
    gameController.slotMachine.clearDimSymbolIds();
  }

  if (!gameController.isRespinning) {
    gameController.centreDevil.disappear(gameController.inFreeSpins);
  }

  if (gameData.reelsSpinning > 0) {
    if (gameController.inFreeSpins) {
      gameController.centreDevil.slamStop();
    }
    gameController.reelsToSlam = [];

    if (!gameController.canSecondSlam && !gameController.anticipationVisible) {
      for (let i = 0; i < gameData.reels.length; ++i) {
        if (!(gameController.anticipateCentreReel && i === 7)) {
          gameController.reelsToSlam.push(i);
        }
      }
    } else if (!gameController.canSecondSlam) {
      for (let i = 0; i < gameData.reels.length; ++i) {
        gameController.reelsToSlam.push(i);
      }
    } else {
      gameController.reelsToSlam.push(7);
    }

    gameController.slotMachine.slamReels(gameController.reelsToSlam);

    if (gameController.anticipateCentreReel && !gameController.canSecondSlam && gameController.anticipationVisible) {
      gameController.slamStopped = false;
      gameController.canSlamStop = true;
      gameController.canSecondSlam = true;
      messageBus.postImmediate("secondSlam");
    }
  }
};

gameController.getRandomBezierPoint = function (startPoint, endPoint, distanceScaler, direction) {
  // pass in undefined for unneeded parameters and it will pick a hopefully sensible default value
  // distanceScaler - (0.0 - 1.0) - Distance to move the bezier point away from the line - 0.0 = no movement, 1.0 = full line distance
  if (distanceScaler === undefined) {
    distanceScaler = 0.25; // Default to 25% of the line distance
  } else {
    // Clamp the distance scaler to 0.0 - 1.0
    distanceScaler = Math.min(1.0, Math.max(0.0, distanceScaler));
  }
  // direction - (0 or 1) - direction to move the bezier point - 0 = right, 1 = left
  // from the perspective of the line direction, stood at start point looking at end point
  if (direction !== 0 && direction !== 1) {
    direction = Math.floor(Math.random() * 2);
  }

  const midPoint = {
    x: (startPoint.x + endPoint.x) / 2,
    y: (startPoint.y + endPoint.y) / 2,
  };
  const directionVector = {
    x: endPoint.x - startPoint.x,
    y: endPoint.y - startPoint.y,
  };
  const mainLineMagnitude = Math.sqrt(directionVector.x ** 2 + directionVector.y ** 2);
  const distance = mainLineMagnitude * distanceScaler;
  const perpendicularVector = { x: -directionVector.y, y: directionVector.x };
  const perpendicularMagnitude = Math.sqrt(perpendicularVector.x ** 2 + perpendicularVector.y ** 2);
  perpendicularVector.x /= perpendicularMagnitude;
  perpendicularVector.y /= perpendicularMagnitude;
  const scaledPerpendicularVector = {
    x: perpendicularVector.x * distance,
    y: perpendicularVector.y * distance,
  };

  let xPos;
  let yPos;

  if (direction === 0) {
    xPos = midPoint.x + scaledPerpendicularVector.x;
    yPos = midPoint.y + scaledPerpendicularVector.y;
  } else {
    xPos = midPoint.x - scaledPerpendicularVector.x;
    yPos = midPoint.y - scaledPerpendicularVector.y;
  }

  const bezierPoint = { x: xPos, y: yPos };
  return bezierPoint;
};

gameController.calculateMagnitude = function (startPos, endPos) {
  const deltaX = endPos.x - startPos.x;
  const deltaY = endPos.y - startPos.y;
  return Math.sqrt(deltaX * deltaX + deltaY * deltaY);
};

gameController.calculateQuadraticBezierPosition = function (t, P0, P1, P2) {
  let x = Math.pow(1 - t, 2) * P0.x + 2 * (1 - t) * t * P1.x + Math.pow(t, 2) * P2.x;
  let y = Math.pow(1 - t, 2) * P0.y + 2 * (1 - t) * t * P1.y + Math.pow(t, 2) * P2.y;
  return { x: x, y: y };
};

gameController.doPayWins = function (winTask) {
  const linesWon = winTask.data.paylines.winningLines.length > 0;

  if (linesWon) {
    gameController.canSkipWin = true;
  }

  gameController.canSlamStop = false;
  gameController.isCapped = winTask.data.isCapped;
  gameController.winTask = winTask;
  gameController.winTask.join();

  gameController.slotMachine.clearDimSymbolIds();

  gameController.reelsPrize = winTask.data.paylines.totalLineWinnings;

  if (!gameController.inFreeSpins) {
    gameController.preFSReelPrize = gameController.reelsPrize;
    if (gameController.winTask.data.collectableAwards.winAmount > 0 && !gameController.respinModifier.isAwarded) {
      gameData.winningsMeter.add(
        gameController.winTask.data.paylines.totalLineWinnings - gameController.winTask.data.collectableAwards.winAmount
      );
    } else {
      gameData.winningsMeter.add(gameController.winTask.data.paylines.totalLineWinnings);
    }
    gameController.totalWinnings += gameController.winTask.data.paylines.totalLineWinnings;
    gameController.lastPayWinsData = winTask.data.paylines;
  } else {
    gameController.lastPayWinsData = {
      totalLineWinnings: winTask.data.paylines.winningLines.reduce((acc, curr) => {
        return acc + curr.winAmount;
      }, gameController.collectableAwards.winAmount),
    };
  }

  let stake = resourceManager.getController("stakeController").CurrentStake;

  if (gameController.winTask.data.paylines.totalLineWinnings > stake) {
    gameController.playLogoSpine();

    musicManager.stepUp();
  }
  gameController.convertWinTaskData(winTask.data.paylines);

  timerManager.addTimeout(1, function () {
    gameController.canSetWinningsText() && gameController.dimNoneWinningSymbols(winTask.data.paylines.winningLines);

    if (linesWon && gameController.lastPayWinsData.totalLineWinnings > stake) {
      gameController.winControllerMain.startAnimations(
        gameController.winTask.data.paylines,
        resourceManager.getController("stakeController").CurrentStake,
        gameController.slotMachine,
        function () {
          gameController.winlinePreAnimsDone();
        }
      );
    } else {
      soundManager.play("winLTS");

      timerManager.addTimeout(200, () => {
        gameController.winlinePreAnimsDone();
      });
    }

    gameController.canSetWinningsText() && gameController.displaySymbolFrames(gameController.winTask.data.paylines);
  });
};

gameController.convertWinTaskData = function (data) {
  //take data and convert reel, row to index, 0
  for (i = 0; i < data.winningLines.length; i++) {
    for (j = 0; j < data.winningLines[i].positions.length; j++) {
      let reel = helper.convertReelRowToIndex(
        data.winningLines[i].positions[j].reel,
        data.winningLines[i].positions[j].row
      );
      data.winningLines[i].positions[j].reel = reel;
      data.winningLines[i].positions[j].row = 0;
    }
  }
};

gameController.returnAllWilds = function () {
  gameController.currentWilds.forEach((wild) => {
    gameController.wildOverlays.push(wild.overlay);
    wild.overlay.visible = false;
  });
  gameController.currentWilds = [];
};

gameController.displaySymbolFrames = function (data) {
  let symbols = new Set();

  for (let i = 0; i < data.winningLines.length; i++) {
    for (let j = 0; j < data.winningLines[i].positions.length; j++) {
      const symbol = JSON.stringify({
        reel: data.winningLines[i].positions[j].reel,
        row: data.winningLines[i].positions[j].row,
      });
      symbols.add(symbol);
    }
  }

  for (let i = 0; i < symbols.size; i++) {
    const sym = JSON.parse(Array.from(symbols)[i]);
    let mainReelScaleX = resourceManager.get("slotContainer").scale.x;
    let mainReelScaleY = resourceManager.get("slotContainer").scale.y;
    gameController.symbolFramePanels[sym.reel].scale.set(mainReelScaleX, mainReelScaleY);

    const pos = helpers.getSymbolPos(sym.reel, sym.row);
    gameController.symbolFramePanels[sym.reel].x = pos.x;
    gameController.symbolFramePanels[sym.reel].y = pos.y;
    gameController.symbolFramePanels[sym.reel].gotoAndStop(0);
    gameController.symbolFramePanels[sym.reel].visible = true;
    gameController.symbolFramePanels[sym.reel].onComplete = () => {
      gameController.symbolFramePanels[sym.reel].visible = false;
    };
    gameController.symbolFramePanels[sym.reel].play();
  }
};

gameController.stopSymbolFrameDisplay = function () {
  for (let i = 0; i < 15; i++) {
    gameController.symbolFramePanels[i].visible = false;
    gameController.symbolFramePanels[i].gotoAndStop(0);
  }
};

gameController.dimNoneWinningSymbols = function (winningLines) {
  const allPositions = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14];

  const allWinningPositions = winningLines
    .reduce((acc, { positions }) => {
      acc.push(...positions);
      return acc;
    }, [])
    .map(({ reel }) => reel);

  const uniqueWinningPositions = [...new Set(allWinningPositions)];

  const symbolsToDim = allPositions
    .filter((reelIndex) => !uniqueWinningPositions.includes(reelIndex))
    .map((reelIndex) => {
      return { reel: reelIndex };
    });

  const collectableAwardsIndices = gameController.spinToCollectables.map((collectable) => {
    const collectableIndex = helper.convertReelRowToIndex(collectable.coord.reel, collectable.coord.row);
    return collectableIndex;
  });

  const coinsOnlyNoWinlines = collectableAwardsIndices.length && !winningLines.length;

  const convertedSymbolsToDim = symbolsToDim.filter(({ reel }) => !collectableAwardsIndices.includes(reel));

  const dimTime = collectableAwardsIndices.length ? 0 : 0.3;
  gameController.slotMachine.dimSymbols(coinsOnlyNoWinlines ? convertedSymbolsToDim : symbolsToDim, true, dimTime);
};

gameController.dimNoneCollectableSymbols = () => {
  const allPositions = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14];

  const collectableAwardsIndices = gameController.spinToCollectables.map((collectable) => {
    const collectableIndex = helper.convertReelRowToIndex(collectable.coord.reel, collectable.coord.row);
    return collectableIndex;
  });

  const nonCollectableSymbols = allPositions
    .filter((reel) => !collectableAwardsIndices.includes(reel))
    .map((reel) => {
      return { reel };
    });

  gameController.slotMachine.dimSymbols(nonCollectableSymbols, true, 0.3);
};

gameController.dimFullReel = function (reel, dim, time = 0) {
  let symbolsToDim = [];

  //for (let j = 0; j < 7; ++j) {
  symbolsToDim.push({ reel: reel, row: 0 });
  //}
  gameController.slotMachine.dimSymbols(symbolsToDim, dim, time);
  //gameController.symbolOverlayDisplay.dimSymbols(symbolsToDim, dim, time);
};

gameController.winlinePreAnimsDone = function (postRespinTask = undefined) {
  if (postRespinTask) {
    gameController.postRespinTask = postRespinTask;
    gameController.postRespinTask.join();
  }

  let isBigWin = false;

  if (!gameController.inFreeSpins) {
    isBigWin = gameController.bigWin.willTriggerBigWin(gameController.reelsPrize);
  }

  let setWinningText = false;
  if (postRespinTask) {
    const currentStake = resourceManager.getController("stakeController").getBaseStake();
    setWinningText =
      gameController.inFreeSpins ||
      (!gameController.inFreeSpins && postRespinTask.data.postRespinData.totalWinnings < currentStake * 10);
  } else {
    const hasWinningLines = gameController.winTask.data.paylines.winningLines.length > 0;
    const inFreeSpinsNoPreRespins = gameController.inFreeSpins && !gameController.preRespins;
    const inFreeSpinsWithWinningLines = gameController.inFreeSpins && gameController.preRespins && hasWinningLines;
    const inFreeSpinsPostRespins = gameController.inFreeSpins && gameController.hasRespun;

    setWinningText =
      gameController.canSetWinningsText() &&
      (inFreeSpinsNoPreRespins || inFreeSpinsWithWinningLines || !gameController.inFreeSpins || inFreeSpinsPostRespins);
  }

  if (!gameController.isCapped && !isBigWin && setWinningText) {
    gameController.setWinningsText();
    gameData.winningsText.animate(true, false);
    gameData.winningsText.show(true, 0);
  }

  gameController.doBigWin();
};

gameController.doBigWin = function () {
  let winnings;
  if (!gameController.respinModifier.isAwarded) {
    gameController.canSkipWin = true;
  }
  if (gameController.hasRespun) {
    gameController.canSkipWin = true;
    winnings = gameController.postRespinTask.data.postRespinData.totalWinnings;
  } else {
    winnings = gameController.lastPayWinsData.totalLineWinnings;
  }

  let isBigWin = false;

  if (!gameController.inFreeSpins) {
    isBigWin = gameController.bigWin.willTriggerBigWin(winnings);
  }

  if (isBigWin && !gameController.inFreeSpins && !gameController.preRespins) {
    gameController.bigWin.start(
      winnings,
      function () {
        gameController.bigWinDone();
        gameController.devilCharacter.idleLoop();
        gameController.reelBorderFire.adjustIntensity(false, true);
      },
      gameController.isCapped
    );
  } else {
    timerManager.addTimeout(1000, () => {
      gameController.bigWinDone();
    });
  }
};

gameController.bigWinDone = function () {
  resourceManager.getContainer("DemoContainer").visible = true;

  if (gameController.inFreeSpins && !gameController.hasRespun) {
    const hasWinningLines = gameController.winTask.data.paylines.winningLines.length > 0;
    const shouldSkip = !hasWinningLines && gameController.preRespins;

    if (!shouldSkip) {
      const usePreRespinWinnings = gameController.preRespins && hasWinningLines;

      let winnings = usePreRespinWinnings
        ? gameController.preRespinWinnings
        : gameController.lastPayWinsData.totalLineWinnings - gameController.collectableAwards.winAmount;

      gameData.winningsMeter.countUp(winnings, 1500);
    }

    gameController.totalWinnings += gameController.lastPayWinsData.totalLineWinnings;
  }

  gameController.bigWinFinished = true;

  gameController.winlineAnimsDone();
};

gameController.winlineAnimsDone = async function () {
  const currentStake = resourceManager.getController("stakeController").getBaseStake();

  if (
    gameController.canSetWinningsText() ||
    (gameController.hasRespun && gameController.postRespinTask.data.postRespinData.totalWinnings < currentStake * 10)
  ) {
    gameController.slotMachine.clearDimSymbolIds();
    gameController.slotMachine.dimAllSymbols(false, 0.1);
    gameController.setWinningsText(true);
    gameData.winningsText.show(true, 0);
    gameData.winningsText.animateOut();
  }

  gameController.canSkipWin = false;

  gameController.winlineAnimator.clearWinlines();

  if (this.checkForDevilSymbol() && !gameController.inFreeSpins) {
    await gameController.checkToCollectMeter();
  }

  if (!gameController.postRespinTask) {
    gameController.winTask.leave();
    gameController.winTask = undefined;
  } else {
    gameController.postRespinTask.leave();
    gameController.postRespinTask = undefined;
  }
};

gameController.canSetWinningsText = () => {
  const canSet =
    (gameController.respinModifier.isAwarded && gameController.spinTask.data.hasPaylines) ||
    !gameController.respinModifier.isAwarded ||
    (gameController.inFreeSpins && gameController.hasRespun);

  return canSet;
};

gameController.skipWinAnimations = function () {
  gameController.bigWin.skip(gameController.winlineAnimsDone);
};

gameController.isAnimatingWins = function () {
  return gameController.winTask !== undefined;
};

gameController.skipWin = function () {
  gameController.skipWinsPressed = true;
  gameController.canSkipWin = false;

  if (gameController.winAnimationDelayTimer !== undefined) {
    timerManager.stop(gameController.winAnimationDelayTimer);
    gameController.winAnimationDelayTimer = undefined;
  }

  if (gameController.winningsCountup !== undefined) {
    gameController.winningsCountup.progress(1);
    gameController.winningsCountup = undefined;
  }

  gameController.setWinningsText(true);

  gameController.bigWin.skip();
  gameController.winControllerMain.skipAnimations();
  gameController.winlineAnimator.skipAnimation();
};

gameController.getCashOverlay = function () {
  let overlay = undefined;

  if (gameController.cashOverlays.length > 0) {
    overlay = gameController.cashOverlays.pop();
  } else {
    overlay = resourceManager.createObject(
      "text",
      "cashOverlay" + gameController.cashOverlaysCreated,
      "particlesContainerFront",
      {
        text: gdk.formatCurrency(0),
        anchor: 0.5,
        fontDefinition: "cashFish",
        maxWidth: 140,
        anchor: 0.5,
      }
    );
    gameController.cashOverlaysCreated++;
  }
  return overlay;
};

gameController.getMultiplierOverlay = function () {
  let overlay = undefined;

  if (gameController.multiplierOverlays.length > 0) {
    overlay = gameController.multiplierOverlays.pop();
  } else {
    overlay = resourceManager.createObject(
      "text",
      "multiplierOverlay" + gameController.multiplierOverlaysCreated,
      "fishermenMultiplierOverlayContainer",
      {
        text: "x2",
        anchor: 0.5,
        fontDefinition: "fishermanMultiplier",
        anchor: 0.5,
      }
    );
    gameController.multiplierOverlaysCreated++;
  }
  return overlay;
};

gameController.getMeterOverlay = function () {
  let overlay = undefined;

  if (gameController.meterOverlays.length > 0) {
    overlay = gameController.meterOverlays.pop();
  } else {
    frame = resourceManager.createObject(
      "sprite",
      "meterBackground" + gameController.meterOverlaysCreated,
      "fishermenOverlayContainer",
      { fileName: "Base_Game/TH_Fisherman_Meter.png", anchor: 0.5, alpha: 1 }
    );

    cash = resourceManager.createObject(
      "meter",
      "meterOverlay" + gameController.meterOverlaysCreated,
      "fishermenOverlayContainer",
      {
        initialValue: 0,
        anchor: 0.5,
        fontDefinition: "cashFish",
        maxWidth: 140,
        anchor: 0.5,
      }
    );

    overlay = { frame, cash };
    gameController.meterOverlaysCreated++;
  }
  return overlay;
};

gameController.reelInFish = function (cb) {
  soundManager.play("winCountUp");

  const fishWin = gameController.fishermenAwards.fish[gameController.currentReelingIndex];
  const fishermanCoord = fishWin.collectCoord;
  const fishermanPos = helpers.getSymbolPos(fishermanCoord.reel, fishermanCoord.row);
  const fishes = fishWin.fishs;
  const win = fishWin.winAmountBeforeMultiplier;
  const winMultipled = fishWin.winAmount;
  const multiplierAmount = fishWin.multiplier;
  const fishermanOffset = 55;
  const cashOffset = 60;
  const capped = fishWin.winCapped;
  const capAmount = gameController.globalHelperGetBaseStake() * 5000;

  const fishermanOverlay = gameController.getMeterOverlay();
  const fishermanCash = fishermanOverlay.cash;
  const fishermanFrame = fishermanOverlay.frame;
  const scale = resourceManager.get("slotContainer").scale;

  fishermanCash.x = fishermanPos.x;
  fishermanCash.y = fishermanPos.y + fishermanOffset * scale.x;
  fishermanCash.set(0);
  fishermanCash.visible = true;
  fishermanCash.scale = scale;

  fishermanFrame.x = fishermanPos.x;
  fishermanFrame.y = fishermanPos.y + fishermanOffset * scale.x;
  fishermanFrame.visible = true;
  fishermanFrame.scale = scale;

  gameController.currentMeterOverlays.push({
    overlay: fishermanOverlay,
    coord: fishermanCoord,
    yOffset: fishermanOffset,
  });

  const duration = 0.9;
  const delayInt = 0.3;
  let delay = 0;

  const len = fishes.length;

  fishermanCash.countUp(Math.min(capAmount, win), (duration + delayInt * len) * 1000, () => {
    soundManager.stop("winCountUp");
    soundManager.play("winCountUpEnd");
  });

  const symData = {
    cell: fishermanCoord,
    symbolId: 0,
  };
  const symbols = [symData];
  gameController.symbolAnimator.animateSymbols(symbols, gameController.slotMachine, true, false, function () {});

  let symbolsToAnimate = [];

  gameController.crtCashAnimations = [];

  for (let i = 0; i < len; i++) {
    const fish = fishes[i];
    const coord = fish.coord;
    const fishOverlay = gameController.getCashOverlay();
    const pos = helpers.getSymbolPos(coord.reel, coord.row);
    fishOverlay.x = pos.x;
    fishOverlay.y = pos.y + cashOffset * scale.x;
    fishOverlay.text = gdk.formatCurrency(fish.amount);
    fishOverlay.visible = true;
    fishOverlay.scale = scale;

    const fishReel = resourceManager.get("slotContainer:reelContainer:reel" + coord.reel);
    const sym = fishReel.getReelSymbol(coord.row);
    const symData = {
      cell: coord,
      symbolId: sym,
    };
    symbolsToAnimate.push(symData);

    const reel = resourceManager.get("slotContainer:reelContainer:reel" + fishermanCoord.reel);

    const anim = gsap.to(fishOverlay, {
      duration,
      delay,
      x: fishermanPos.x,
      y: fishermanPos.y + fishermanOffset * scale.x,
      ease: "linear",
      onComplete: () => {
        gameController.cashOverlays.push(fishOverlay);
        fishOverlay.visible = false;

        if (i === fishes.length - 1) {
          timerManager.addTimeout(800, function () {
            const multiply = multiplierAmount > 1;
            const timer = multiply ? 1100 : 1;

            if (!capped) {
              if (multiply) {
                gameController.addMultiplier(0.5);
                fishermanCash.countUp(winMultipled - win, 0.8 * 1000);
                reel.dimMultiplier(fishermanCoord.row);
              } else {
                fishermanCash.set(winMultipled);
              }
            }

            timerManager.addTimeout(timer, function () {
              gameController.currentReelingIndex++;

              if (gameController.currentReelingIndex >= gameController.fishermenToReel) {
                gameController.returnAllMultipliers();
                gameController.crtCashAnimations = [];
                cb();
              } else {
                gameController.reelInFish(cb);
              }
            });
          });
        }
      },
    });

    gameController.crtCashAnimations.push(anim);
    delay += delayInt;
  }

  if (!gameController.animatedReelFish) {
    gameController.symbolAnimator.animateSymbols(symbolsToAnimate, gameController.slotMachine, true, false, () => {});
    gameController.animatedReelFish = true;
  }
};

gameController.addMultiplier = function (duration = 0.6) {
  const multi = gameController.currentMutlipliers.shift().multiplier;
  const startX = multi.x;
  const startY = multi.y;

  gsap.to(multi, {
    duration,
    x: startX - 40,
    y: startY + 80,
    ease: "power1.in",
  });

  gsap.to(multi.scale, {
    duration,
    x: 0,
    y: 0,
    ease: "back.in(4)",
    onComplete: () => {
      gameController.multiplierOverlays.push(multi);
      multi.visible = false;
    },
  });
};

gameController.returnAllMultipliers = function () {
  gameController.currentMutlipliers.forEach((multi) => {
    gameController.multiplierOverlays.push(multi.multiplier);
    multi.multiplier.visible = false;
  });
  gameController.currentMutlipliers = [];
};

gameController.toggleMultiplierVisible = function (show) {
  gameController.showMultipliers = show;
  gameController.currentMutlipliers.forEach((multi) => {
    multi.multiplier.visible = show;
  });
};

gameController.hookComplete = function () {
  gameController.finishedHooking = true;
};

gameController.onRespinData = function (task) {
  gameController.respinTask = task;
  gameController.respinTask.join();

  gameController.canSkipWin = false;
  gameController.canSlamStop = false;

  const collectableIds = [5, 6, 7, 22, 23, 8, 9, 10, 11];

  const collectablesValueToID = {
    50: 5,
    150: 6,
    250: 7,
    100: 22,
    200: 23,
    Mini: 8,
    Minor: 9,
    Major: 10,
    Grand: 11,
  };

  // turn the coordinates into reels that are actually spinning e.g. 0-14
  const rowsPerReel = 3;
  gameController.respinData = task.data.respinData.respins.map((respin) => {
    const allCoords = [...(respin.newCollectables || []), ...(respin.blanks || [])].map((respinData) => {
      const reelIndex = respinData.coord.reel * rowsPerReel + respinData.coord.row;

      let symbol;
      if (respinData.type === "Cash") {
        const baseStake = gameController.inBuyABonus
          ? gameController.currentStake
          : resourceManager.getController("stakeController").getBaseStake();
        const getValue = respinData.amount / (baseStake / 100);
        symbol = collectablesValueToID[getValue];
      } else if (respinData.type === "Gem") {
        symbol = collectablesValueToID[respinData.potName];
      } else {
        symbol = respinData.symbol;
      }

      return { reelIndex, symbol };
    });
    return allCoords.sort((a, b) => a.reelIndex - b.reelIndex);
  });

  gameController.coinsLandedTracker = task.data.respinData.respins.map((respin) => {
    return respin.newCollectables.map((newCollect) => newCollect.coord.reel * rowsPerReel + newCollect.coord.row);
  });

  gameController.respinInitialCoinsLanded = gameController.convertedReelResults.map((smbID) =>
    collectableIds.includes(smbID[0])
  );

  gameController.isRespinning = true;
  gameController.isLastRespin = false;
  gameController.canSlamStop = false;
  gameController.respinSymbolTracker = gameController.convertedReelResults;
  gameController.doRespin();
};

gameController.freespinsComplete = function (value) {
  gameController.reelsPrize = gameController.preFSReelPrize;
  gameController.featurePrize = value;
  gameController.stateMachine.switchState("IDLE");
};

gameController.onFreespinsStart = async function () {
  gameController.cancelAutoplay();
  gameController.inFreeSpins = true;
  gameController.respinFinished = false;
};

gameController.onFreespinsEnd = function () {
  gameController.returnAllMultipliers();
  gameController.justHadFreeSpins = true;
  gameController.inFreeSpins = false;
  gameController.anchorLocks = 0;

  gameController.allLockedFishermen.forEach((fisherman) => {
    const coord = fisherman.coord;
    const reelObj = resourceManager.get("slotContainer:reelContainer:reel" + coord.reel);
    reelObj.setReelSymbol(coord.row, 22);
  });
};

gameController.onFeatureStart = function (task) {};

gameController.globalHelperGetStake = function () {
  let stake = gameData.stakes[gameData.currentStakeIndex];
  if (gameController.boughtBonus && gameController.buyBonusHigh) {
    stake *= buyBonusPopup.gameConfig.data.buyBonusCostFreeSpinsHigh;
  } else if (gameController.boughtBonus && gameController.buyBonusMed) {
    stake *= buyBonusPopup.gameConfig.data.buyBonusCostFreeSpinsMed;
  } else if (gameController.boughtBonus && gameController.buyBonusLow) {
    stake *= buyBonusPopup.gameConfig.data.buyBonusCostFreeSpinsLow;
  } else if (gameData.currentStakeIndex === -1) {
    stake = gameController.currentStake;
  }
  return stake;
};

gameController.globalHelperGetBaseStake = function () {
  if (!gameController.gameLoaded) {
    return;
  }

  return resourceManager.getController("stakeController").getBaseStake();
};

gameController.recoverGame = function (task) {
  if (task.data.metaData == "lucky" || task.data.metaData == "lucky_max") {
    gameData.encoreEnabled = true;

    const encoreButtonLB = resourceManager.get("buttonContainer:buttonBar:luckyBetToggleButton");
    encoreButtonLB.setRecovery();
  }

  resourceManager.get("helpPageScrollContainer:helpPageScroll").close();

  gameController.inRecovery = true;

  if (["buyABonusLow", "buyABonusMed", "buyABonusHigh"].includes(task.data.metaData) && task.data.metaValue) {
    gameController.inBuyABonus = true;

    gameController.inBuyABonusRecovery = true;
    // we cant spin the reels, we need to wait for the panel to be removed
    // gameController.initNewSpin();
    //TODO set levels properly
    gameController.chests._showBonusChest(true, task.data.metaBonusBuyChestColour);

    if (task.data.metaData === "buyABonusLow") {
      gameController.buyBonusType = "BONUS_BUY_LOW";
      gameController.buyBonusLow = true;
    } else if (task.data.metaData === "buyABonusMed") {
      gameController.buyBonusType = "BONUS_BUY_MED";
      gameController.buyBonusMed = true;
    } else {
      gameController.buyBonusType = "BONUS_BUY_HIGH";
      gameController.buyBonusHigh = true;
    }

    gameController.bonusBetStake = task.data.bpl;

    let baseStake = gameData.recoveryStake;

    if (baseStake === undefined) {
      baseStake = gameController.currentStake;
    }
    const stakeController = resourceManager.getController("stakeController");
    stakeController.setStakeMultiplier(1);

    let stakes = stakeController.Stakes;
    let returnStake = stakes.find((stake) => stake === baseStake);

    if (!returnStake) {
      returnStake = stakes[0];
    }

    mode = gameController.getBonusMode(task.data.metaData);

    stakeController.requestChangeStake(returnStake);
    stakeController.requestChangeStake(baseStake, mode);

    gameData.stakeMeter.set(baseStake);
  } else {
    musicManager.onGameStart();
    gameController.initNewSpin();

    let stakeController = resourceManager.getController("stakeController");

    let baseStake = stakeController.BaseStake;
    let bpl = stakeController.BaseStake / stakeController.CurrentWinLineCount;
    let luckyBetEnabled = gameData.encoreEnabled;
    gameController.chests.toggleGoldenBet(gameData.encoreEnabled);

    stakeController.setStakeMultiplier(luckyBetEnabled ? 1.5 : 1);
    gameController.onStakeChanged(baseStake * (luckyBetEnabled ? gameData.luckyBetUplift : 1));
    stakeController.broadcastCurrentStake();
  }
};

gameController.getBonusMode = function (mode) {
  if (mode === "buyABonusLow") {
    mode = "BONUS_BUY_LOW";
  } else if (mode === "buyABonusMed") {
    mode = "BONUS_BUY_MED";
  } else if (mode === "buyABonusHigh") {
    mode = "BONUS_BUY_HIGH";
  }

  return mode;
};

gameController.readyToStart = function () {
  if (gameController.popupShown) {
    return;
  }

  gameController.popupShown = true;
  musicManager.onGameIntro();

  if (gameController.inRecovery) {
    gameController.inRecovery = false;
    musicManager.unlockIntroComplete();
  } else {
    gameController.splashScreenComplete(() => {
      musicManager.unlockIntroComplete();
    });
  }
};

gameController.onAbortGame = function () {
  gameController.slotMachine.abortSpin();
  gameController.centreDevil.disappear();

  Loader.setStartingSymbols();

  gameController.reelBorderFire.adjustIntensity(false);
  gameController.reelBorderFire.switchColour("Normal");
};

gameController.replayComplete = function () {
  gameController.cyclingWins = true;
  gameController.cycleWins();
};

gameController.onOrientationChange = function () {
  let autoPlayButtonVisibility = resourceManager.get("buttonContainer:buttonBar:autoplayButton").visible;
  if (!autoPlayButtonVisibility) {
    autoplayManager.dialog.buttonGlow.visible = false;
  }

  gameController.stopSparkles();

  gameController.crtCashAnimations.forEach((anim) => {
    anim.progress(1);
  });

  gameController.setDarkOverlay(true);

  const scale = resourceManager.get("slotContainer").scale;

  gameController.currentMutlipliers.forEach((multi) => {
    const pos = helpers.getSymbolPos(multi.coord.reel, multi.coord.row);
    multi.multiplier.x = pos.x + multi.xPos * scale.x;
    multi.multiplier.y = pos.y + multi.yPos * scale.x;
    multi.multiplier.scale = scale;
  });

  gameController.currentWilds.forEach((wild) => {
    const pos = helpers.getSymbolPos(wild.coord.reel, wild.coord.row);
    wild.overlay.x = pos.x + wild.xPos * scale.x;
    wild.overlay.y = pos.y + wild.yPos * scale.x;
    wild.overlay.scale = scale;
  });

  gameController.currentMeterOverlays.forEach((overlay) => {
    const pos = helpers.getSymbolPos(overlay.coord.reel, overlay.coord.row);
    overlay.overlay.cash.x = pos.x;
    overlay.overlay.cash.y = pos.y + overlay.yOffset * scale.x;
    overlay.overlay.cash.scale = scale;
    overlay.overlay.frame.x = pos.x;
    overlay.overlay.frame.y = pos.y + overlay.yOffset * scale.x;
    overlay.overlay.frame.scale = scale;
  });

  gameController.respinAnticipationSymbolFrames.forEach((symbolFrame, index) => {
    const pos = helpers.getSymbolPos(index, 0);
    symbolFrame.x = pos.x;
    symbolFrame.y = pos.y - 20 * scale.y;
    symbolFrame.scale = scale;
  });

  gameController.symbolFramePanels.forEach((symbolFrame, index) => {
    const pos = helpers.getSymbolPos(index, 0);
    symbolFrame.x = pos.x;
    symbolFrame.y = pos.y;
    symbolFrame.scale = scale;
  });
};

gameController.onLayoutChange = function () {
  if (gameController.symbolFramePanels.length > 0) {
    for (let i = 0; i < 15; i++) {
      gameController.symbolFramePanels[i].position = helpers.getSymbolPos(i, j);
    }
  }
};

gameController.onModal = function (event) {
  if (event.reason && event.reason !== "") {
    if (event.reason === "Platform Paused") {
      gameController.platformPaused = true;
    } else if (event.data && event.data === "Platform Popup Open") {
      gameController.platformPopupActive = true;
    }
  } else if (event.data) {
    if (event.data === "Platform Popup Close" && !gameController.platformPaused) {
      gameController.platformPopupActive = false;
    } else if (event.data === "Platform Resume") {
      gameController.platformPaused = false;
    }

    if (gameController.platformPopupActive || gameController.platformPaused) {
      messageBus.post("game:modal", {
        reason: "Keep locked",
        data: "Keep locked",
      });
    }
  }
};

gameController.createParticleEmitters = function () {
  gameController.leftEmitter = particleManager.createEmitter(
    "throwParticleRed",
    "centreDevil:CentreDevilContainer",
    0,
    0,
    false
  );
  gameController.rightEmitter = particleManager.createEmitter(
    "throwParticleRed",
    "centreDevil:CentreDevilContainer",
    0,
    0,
    false
  );
  gameController.leftEmitter.particleEmitter.emit = false;
  gameController.leftEmitter.visible = false;
  gameController.rightEmitter.particleEmitter.emit = false;
  gameController.rightEmitter.visible = false;
};

gameController.emitCoins = function () {
  gameController.coinBurstEmitter.particleEmitter.emit = true;

  timerManager.addTimeout(600, () => {
    gameController.coinBurstEmitter.particleEmitter.emit = true;
  });
};

gameController.shakeGoldenChest = function (canShake) {
  if (!canShake) {
    return;
  }

  gameController.chests._wiggleChest("right", false);
};

gameController.shootParticle = async function (left, right) {
  if (left && right) {
    await Promise.all([
      gameController.shootParticleTween(true, gameController.leftEmitter),
      gameController.shootParticleTween(false, gameController.rightEmitter),
    ]);
    await Promise.all([
      gameController.chests._wiggleChest(gameController.inBuyABonus ? "leftBonus" : "left"),
      gameController.chests._wiggleChest(gameController.inBuyABonus ? "rightBonus" : "right"),
    ]);
  } else if (left) {
    await gameController.shootParticleTween(true, gameController.leftEmitter);
    await gameController.chests._wiggleChest(gameController.inBuyABonus ? "leftBonus" : "left");
  } else if (right) {
    await gameController.shootParticleTween(false, gameController.rightEmitter);
    await gameController.chests._wiggleChest(gameController.inBuyABonus ? "rightBonus" : "right");
  }
};

gameController.shootParticleTween = async function (left, emitter) {
  return new Promise((resolve) => {
    const emitterX = left ? gameController.leftEmitterSpawnX : gameController.rightEmitterSpawnX;
    const emitterY = left ? gameController.leftEmitterSpawnY : gameController.rightEmitterSpawnY;
    emitter.particleEmitter.spawnPos = { x: emitterX, y: emitterY };
    const target = () => {
      const globalPos = resourceManager
        .get(left ? "chestsContainer:leftChestContainer" : "chestsContainer:rightChestContainer")
        .getGlobalPosition();
      const localPos = emitter.particleEmitter.parent.toLocal(globalPos);
      return { x: localPos.x, y: localPos.y };
    };
    const test = target();
    const chest = resourceManager.get(
      left ? "chestsContainer:leftChestContainer" : "chestsContainer:rightChestContainer"
    );

    const duration = 0.5;

    gsap
      .timeline()
      .call(() => {
        emitter.particleEmitter.emit = true;
        emitter.visible = true;
        // soundManager.play("coinWhoosh");
      })
      .to(emitter.particleEmitter.spawnPos, {
        duration,
        ease: "linear",
        y: test.y,
      })
      .to(
        emitter.particleEmitter.spawnPos,
        {
          duration,
          ease: "linear",
          x: test.x,
          onComplete: () => {
            emitter.particleEmitter.emit = false;
            emitter.visible = false;
            resolve();
          },
        },
        "<"
      );
  });
};

function RNG() {
  const m = 0x80000000;
  const a = 1664525;
  const c = 1013904223;

  let state;

  this.seed = function (newSeed) {
    let seedToUse = newSeed;

    if (typeof newSeed === "string") {
      let hash = 0;
      for (let i = 0; i < newSeed.length; i++) {
        hash = newSeed.charCodeAt(i) + ((hash << 5) - hash);
        hash = hash & hash;
      }
      seedToUse = Math.abs(hash);
    }
    state = seedToUse ? seedToUse : 0;
  };

  this.seed(0);

  this.nextInt = function () {
    state = (a * state + c) % m;
    return state;
  };

  this.nextFloat = function () {
    return this.nextInt() / (m - 1);
  };
}

Reflex.addToUpdate(gameController.update);
messageBus.subscribe("spinner:GameConfigEvent", gameController.onGameConfigEvent);
messageBus.subscribe("spinner:SpinEvent", gameController.doSpin);
messageBus.subscribe("autoplay:started", gameController.autoplayStarted);
messageBus.subscribe("autoplay:ended", gameController.autoplayEnded);
messageBus.subscribe("stake:stakeChanged", gameController.onStakeChanged);
messageBus.subscribe("common:RecoverGame", gameController.recoverGame);
messageBus.subscribe("common:ReadyToStart", gameController.readyToStart);
messageBus.subscribe("common:GameCompleteEvent", gameController.onGameComplete);
messageBus.subscribe("spinner:WinningLinesEvent", gameController.doPayWins);
messageBus.subscribe("game:FeatureAnnounceEvent", gameController.onFeatureStart);
messageBus.subscribe("spinner:FreeSpinsStartEvent", gameController.onFreespinsStart);
messageBus.subscribe("spinner:FreeSpinsEndEventDead", gameController.onFreespinsEnd);
messageBus.subscribe("common:AbortGame", gameController.onAbortGame);
messageBus.subscribe("platform:ReplayComplete", gameController.replayComplete);
messageBus.subscribe("hookComplete", gameController.hookComplete);

messageBus.subscribe("spinner:RespinDataEvent", gameController.onRespinData);
messageBus.subscribe("spinner:PostRespinWinningsEvent", gameController.winlinePreAnimsDone);

Reflex.registerEventHandler("layoutChange", gameController.onLayoutChange);
messageBus.subscribe("game:modal", gameController.onModal);
